// @ts-nocheck
/* eslint-disable */
import type { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
};

export type AddLogbookEntryInput = {
  barometricPressure?: InputMaybe<Scalars['Float']['input']>;
  courseOverGround?: InputMaybe<Scalars['Int']['input']>;
  engineOn?: InputMaybe<Scalars['Boolean']['input']>;
  entryTime: Scalars['DateTime']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  seaState?: InputMaybe<SeaState>;
  speedOverGround?: InputMaybe<Scalars['Float']['input']>;
  windDirection?: InputMaybe<WindDirection>;
  windSpeedKnots?: InputMaybe<Scalars['Int']['input']>;
};

export type AddUserDocumentInput = {
  documentType: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  issuedAt?: InputMaybe<Scalars['DateTime']['input']>;
  issuingBody: Scalars['String']['input'];
  issuingCountry?: InputMaybe<Scalars['String']['input']>;
  levelNotes?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type Assessment = {
  __typename?: 'Assessment';
  assessor: User;
  createdAt: Scalars['DateTime']['output'];
  enrolment: Enrolment;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  numericValue?: Maybe<Scalars['Float']['output']>;
  passed: Scalars['Boolean']['output'];
  ratingValue: Scalars['String']['output'];
};

export type AwardSailingMilesInput = {
  crewRole: CrewRole;
  miles: Scalars['Float']['input'];
  userId: Scalars['ID']['input'];
};

export type BookingRequestInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  totalPriceUsd: Scalars['Float']['input'];
};

export const BookingStatus = {
  Cancelled: 'CANCELLED',
  Confirmed: 'CONFIRMED',
  Pending: 'PENDING'
} as const;

export type BookingStatus = typeof BookingStatus[keyof typeof BookingStatus];
export type Certificate = {
  __typename?: 'Certificate';
  course?: Maybe<Course>;
  description?: Maybe<Scalars['String']['output']>;
  expedition?: Maybe<Expedition>;
  id: Scalars['ID']['output'];
  issuedAt: Scalars['String']['output'];
  issuedBy: User;
  issuedTo: User;
  metadata?: Maybe<Scalars['JSON']['output']>;
  organisation: Organization;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  verificationCode: Scalars['String']['output'];
};

export type CharterBooking = {
  __typename?: 'CharterBooking';
  createdAt: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  guest: User;
  id: Scalars['ID']['output'];
  listing: CharterListing;
  organisation: Organization;
  startDate: Scalars['String']['output'];
  status: BookingStatus;
  totalPriceUsd: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CharterListing = {
  __typename?: 'CharterListing';
  availableFrom: Scalars['String']['output'];
  availableTo: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxGuests: Scalars['Int']['output'];
  organisation: Organization;
  pricePerDayUsd: Scalars['Float']['output'];
  status: CharterListingStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  vessel: Vessel;
};

export const CharterListingStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE'
} as const;

export type CharterListingStatus = typeof CharterListingStatus[keyof typeof CharterListingStatus];
export type Course = {
  __typename?: 'Course';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enrolments: Array<Enrolment>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organization;
  updatedAt: Scalars['DateTime']['output'];
};

export type CreateCharterListingInput = {
  availableFrom: Scalars['String']['input'];
  availableTo: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  maxGuests: Scalars['Int']['input'];
  pricePerDayUsd: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type CreateCourseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateExpeditionInput = {
  departureDate?: InputMaybe<Scalars['DateTime']['input']>;
  kind?: InputMaybe<ExpeditionKind>;
  maxCrew: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  returnDate?: InputMaybe<Scalars['DateTime']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  routeVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOrganisationInput = {
  name: Scalars['String']['input'];
  orgType?: InputMaybe<OrgType>;
  slug: Scalars['String']['input'];
};

export type CreateRouteInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  waypoints: Array<WaypointInput>;
};

export type CreateSkillCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSkillInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<SkillLevelTier>;
  name: Scalars['String']['input'];
  ratingSystem: RatingSystem;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSurveyInput = {
  questions: Scalars['JSON']['input'];
  title: Scalars['String']['input'];
};

export type CreateVesselDocumentInput = {
  docType: VesselDocType;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  issuedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  r2Key: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateVesselInput = {
  beamM?: InputMaybe<Scalars['Float']['input']>;
  berths?: InputMaybe<Scalars['Int']['input']>;
  callSign?: InputMaybe<Scalars['String']['input']>;
  charterCompanyContact?: InputMaybe<Scalars['String']['input']>;
  charterCompanyName?: InputMaybe<Scalars['String']['input']>;
  charterEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  charterStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  draftM?: InputMaybe<Scalars['Float']['input']>;
  enginePowerKw?: InputMaybe<Scalars['Float']['input']>;
  flagState?: InputMaybe<Scalars['String']['input']>;
  fuelCapacityL?: InputMaybe<Scalars['Float']['input']>;
  homePort?: InputMaybe<Scalars['String']['input']>;
  lengthM?: InputMaybe<Scalars['Float']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  maxPassengers?: InputMaybe<Scalars['Int']['input']>;
  mmsiNumber?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  registration?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<VesselSource>;
  vesselType?: InputMaybe<VesselType>;
  waterCapacityL?: InputMaybe<Scalars['Float']['input']>;
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateVesselMaintenanceLogInput = {
  engineHoursAtService?: InputMaybe<Scalars['Float']['input']>;
  expeditionId?: InputMaybe<Scalars['ID']['input']>;
  nextServiceDue?: InputMaybe<Scalars['DateTime']['input']>;
  nextServiceEngineHours?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partsReplaced?: InputMaybe<Scalars['String']['input']>;
  performedAt: Scalars['DateTime']['input'];
  performedBy?: InputMaybe<Scalars['String']['input']>;
  workPerformed: Scalars['String']['input'];
};

export const CrewJoinType = {
  Complimentary: 'COMPLIMENTARY',
  Invited: 'INVITED',
  Paid: 'PAID'
} as const;

export type CrewJoinType = typeof CrewJoinType[keyof typeof CrewJoinType];
export type CrewMembership = {
  __typename?: 'CrewMembership';
  createdAt: Scalars['DateTime']['output'];
  expedition: Expedition;
  id: Scalars['ID']['output'];
  joinType: CrewJoinType;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  role: CrewRole;
  status: CrewMembershipStatus;
  user: User;
  vesselId?: Maybe<Scalars['ID']['output']>;
};

export const CrewMembershipStatus = {
  Cancelled: 'CANCELLED',
  Confirmed: 'CONFIRMED',
  DisembarkedEarly: 'DISEMBARKED_EARLY',
  NoShow: 'NO_SHOW',
  Pending: 'PENDING',
  Waitlisted: 'WAITLISTED'
} as const;

export type CrewMembershipStatus = typeof CrewMembershipStatus[keyof typeof CrewMembershipStatus];
export const CrewRole = {
  Crew: 'CREW',
  FirstMate: 'FIRST_MATE',
  Observer: 'OBSERVER',
  Skipper: 'SKIPPER',
  Student: 'STUDENT'
} as const;

export type CrewRole = typeof CrewRole[keyof typeof CrewRole];
export type Document = {
  __typename?: 'Document';
  fileSizeBytes: Scalars['Int']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  organisation: Organization;
  owner: User;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uploadedAt: Scalars['String']['output'];
};

export type Enrolment = {
  __typename?: 'Enrolment';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  course: Course;
  enrolledAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organisation: Organization;
  status: EnrolmentStatus;
  user: User;
};

export const EnrolmentStatus = {
  Active: 'ACTIVE',
  Completed: 'COMPLETED',
  Withdrawn: 'WITHDRAWN'
} as const;

export type EnrolmentStatus = typeof EnrolmentStatus[keyof typeof EnrolmentStatus];
export type Expedition = {
  __typename?: 'Expedition';
  createdAt: Scalars['DateTime']['output'];
  crew: Array<CrewMembership>;
  departureDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<ExpeditionKind>;
  maxCrew: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organisation: Organization;
  returnDate?: Maybe<Scalars['DateTime']['output']>;
  route?: Maybe<Route>;
  routeVersion?: Maybe<RouteVersion>;
  slug: Scalars['String']['output'];
  status: ExpeditionStatus;
  updatedAt: Scalars['DateTime']['output'];
  vessels: Array<ExpeditionVessel>;
};

export const ExpeditionKind = {
  CoastalCruise: 'COASTAL_CRUISE',
  Delivery: 'DELIVERY',
  Expedition: 'EXPEDITION',
  OffshorePassage: 'OFFSHORE_PASSAGE',
  Race: 'RACE',
  Rally: 'RALLY',
  SailTraining: 'SAIL_TRAINING'
} as const;

export type ExpeditionKind = typeof ExpeditionKind[keyof typeof ExpeditionKind];
export const ExpeditionStatus = {
  Active: 'ACTIVE',
  Cancelled: 'CANCELLED',
  Completed: 'COMPLETED',
  FullyBooked: 'FULLY_BOOKED',
  Open: 'OPEN',
  Planning: 'PLANNING'
} as const;

export type ExpeditionStatus = typeof ExpeditionStatus[keyof typeof ExpeditionStatus];
export type ExpeditionVessel = {
  __typename?: 'ExpeditionVessel';
  assignedAt: Scalars['DateTime']['output'];
  expedition: Expedition;
  id: Scalars['ID']['output'];
  role?: Maybe<VesselRole>;
  vessel: Vessel;
};

export type Expense = {
  __typename?: 'Expense';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  expedition: Expedition;
  id: Scalars['ID']['output'];
  receiptUrl?: Maybe<Scalars['String']['output']>;
  recordedBy: User;
  splits: Array<ExpenseSplit>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ExpensePolicy = {
  __typename?: 'ExpensePolicy';
  approvalThresholdCents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  maxAmountCents?: Maybe<Scalars['Int']['output']>;
  orgId: Scalars['ID']['output'];
  requireReceipt: Scalars['Boolean']['output'];
};

export type ExpenseSplit = {
  __typename?: 'ExpenseSplit';
  amountCents: Scalars['Int']['output'];
  expense: Expense;
  id: Scalars['ID']['output'];
  owedBy: User;
  owedTo: User;
  settledAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ExpenseSummary = {
  __typename?: 'ExpenseSummary';
  expeditionId: Scalars['ID']['output'];
  perPerson: Array<PersonExpenseSummary>;
  totalAmountCents: Scalars['Int']['output'];
};

export type ImportSkillTemplateResult = {
  __typename?: 'ImportSkillTemplateResult';
  categoriesCreated: Scalars['Int']['output'];
  skillsCreated: Scalars['Int']['output'];
};

export type Invitation = {
  __typename?: 'Invitation';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invitedBy: User;
  organisation: Organization;
  roles: Array<OrgRole>;
  status: InvitationStatus;
};

export const InvitationStatus = {
  Accepted: 'ACCEPTED',
  Expired: 'EXPIRED',
  Pending: 'PENDING',
  Revoked: 'REVOKED'
} as const;

export type InvitationStatus = typeof InvitationStatus[keyof typeof InvitationStatus];
export type InviteCrewInput = {
  role?: InputMaybe<CrewRole>;
  userId: Scalars['ID']['input'];
};

export type InviteMemberInput = {
  email: Scalars['String']['input'];
  roles: Array<OrgRole>;
};

export type IssueCertificateInput = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expeditionId?: InputMaybe<Scalars['ID']['input']>;
  issuedToUserId: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  orgId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type JoinExpeditionInput = {
  joinType: CrewJoinType;
  role?: InputMaybe<CrewRole>;
};

export type LogbookEntry = {
  __typename?: 'LogbookEntry';
  author: User;
  barometricPressure?: Maybe<Scalars['Float']['output']>;
  courseOverGround?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  engineOn?: Maybe<Scalars['Boolean']['output']>;
  entryTime: Scalars['DateTime']['output'];
  expedition: Expedition;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  seaState?: Maybe<SeaState>;
  speedOverGround?: Maybe<Scalars['Float']['output']>;
  windDirection?: Maybe<WindDirection>;
  windSpeedKnots?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['Boolean']['output']>;
  acceptInvitation: OrganizationMembership;
  addLogbookEntry: LogbookEntry;
  addSkillLevel: SkillLevel;
  addUserDocument: UserDocument;
  addVesselPhoto: VesselPhoto;
  addWaypoint: RouteWaypoint;
  approveCrewMember: CrewMembership;
  assignVessel: ExpeditionVessel;
  awardSailingMiles: SailingMilesAward;
  cancelBooking: CharterBooking;
  confirmBooking: CharterBooking;
  /** Confirms a completed R2 upload by persisting the r2Key and CDN URL on the document record. */
  confirmUserDocumentUpload: UserDocument;
  createCharterListing: CharterListing;
  createCourse: Course;
  createExpedition: Expedition;
  createOrganisation: Organization;
  createRoute: Route;
  createSkill: Skill;
  createSkillCategory: SkillCategory;
  createSurvey: Survey;
  createVessel: Vessel;
  /** Registers a vessel document after the file has been uploaded to R2. ADMIN or OWNER only. */
  createVesselDocument: VesselDocument;
  /** Creates a maintenance log entry for a vessel. ADMIN or OWNER only. */
  createVesselMaintenanceLog: VesselMaintenanceLog;
  declineCrewMember: CrewMembership;
  deleteCharterListing: CharterListing;
  deleteCourse: Scalars['Boolean']['output'];
  deleteDocument: Scalars['Boolean']['output'];
  deleteExpense: Scalars['Boolean']['output'];
  deleteLogbookEntry: Scalars['Boolean']['output'];
  deleteRoute: Scalars['Boolean']['output'];
  deleteSkill: Scalars['Boolean']['output'];
  deleteSkillAssessment: Scalars['Boolean']['output'];
  deleteSkillCategory: Scalars['Boolean']['output'];
  deleteSurvey: Scalars['Boolean']['output'];
  deleteUserDocument: Scalars['Boolean']['output'];
  deleteVessel: Scalars['Boolean']['output'];
  /** Deletes a vessel document record and removes the associated R2 file. ADMIN or OWNER only. */
  deleteVesselDocument: Scalars['Boolean']['output'];
  deleteVesselPhoto: Scalars['Boolean']['output'];
  enrolUser: Enrolment;
  generateOrgLogoUploadUrl: UploadUrl;
  /** Pre-signs an S3 PUT URL for uploading a vessel document. Returns { uploadUrl, key }. */
  generateVesselDocumentUploadUrl: UploadUrl;
  generateVesselUploadUrl: UploadUrl;
  /** Import a platform skill template into the org — creates categories + skills. Existing skills/categories are not overwritten. */
  importSkillTemplate: ImportSkillTemplateResult;
  inviteCrew: CrewMembership;
  inviteMember: Invitation;
  issueCertificate: Certificate;
  joinExpedition: CrewMembership;
  leaveExpedition: Scalars['Boolean']['output'];
  markAllRead: Scalars['Int']['output'];
  markDisembarkedEarly: CrewMembership;
  markNoShow: CrewMembership;
  markNotificationRead: Notification;
  /** Pre-signs an S3 PUT URL for uploading a document scan. Document record must exist (created via addUserDocument). */
  presignUserDocumentUpload: UserDocumentUploadUrl;
  recordAssessment: Assessment;
  recordExpense: Expense;
  recordSettlement: Settlement;
  recordSkillAssessment: SkillAssessment;
  recordVesselPing: VesselPing;
  regenerateCertificatePdf: Certificate;
  registerDocument: Document;
  reinstateCrewMember: CrewMembership;
  removeCrewMember: Scalars['Boolean']['output'];
  removeMember: Scalars['Boolean']['output'];
  removeSkillLevel: Scalars['Boolean']['output'];
  removeVessel: Scalars['Boolean']['output'];
  removeWaypoint: Scalars['Boolean']['output'];
  reorderWaypoints: Array<RouteWaypoint>;
  requestBooking: CharterBooking;
  /** Requests verification of a document from a skipper or admin. Returns true on success. */
  requestDocumentVerification: Scalars['Boolean']['output'];
  requestUpload: UploadCredentials;
  revokeCertificate: Certificate;
  /**
   * Dev-only: inserts a real notification for the current user and publishes it
   * via pubSub so the notificationReceived subscription fires.
   * Only available when NODE_ENV != production.
   */
  sendTestNotification: Notification;
  setCrewVessel: CrewMembership;
  setVesselCoverPhoto: Vessel;
  settleExpense: ExpenseSplit;
  submitReview: Review;
  updateCharterListing: CharterListing;
  updateCourse: Course;
  updateCrewMembershipRole: CrewMembership;
  updateEnrolmentStatus: Enrolment;
  updateExpeditionStatus: Expedition;
  updateMemberRoles: OrganizationMembership;
  updateOrgPreferences: OrgPreferences;
  updateOrganisation: Organization;
  updateRoute: Route;
  updateSkill: Skill;
  updateSkillCategory: SkillCategory;
  updateSkillLevel: SkillLevel;
  updateSurvey: Survey;
  updateUserDocument: UserDocument;
  updateVessel: Vessel;
  /** Updates an existing maintenance log entry. ADMIN or OWNER only. */
  updateVesselMaintenanceLog: VesselMaintenanceLog;
  updateVesselStatus: Vessel;
  upsertExpensePolicy: ExpensePolicy;
  /** Marks a document as verified. Caller must be SKIPPER, ADMIN, or OWNER in an org the user belongs to. */
  verifyUserDocument: UserDocument;
};


export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationAddLogbookEntryArgs = {
  expeditionId: Scalars['ID']['input'];
  input: AddLogbookEntryInput;
};


export type MutationAddSkillLevelArgs = {
  input: SkillLevelInput;
  skillId: Scalars['ID']['input'];
};


export type MutationAddUserDocumentArgs = {
  input: AddUserDocumentInput;
};


export type MutationAddVesselPhotoArgs = {
  caption?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
  vesselId: Scalars['ID']['input'];
};


export type MutationAddWaypointArgs = {
  input: WaypointInput;
  routeId: Scalars['ID']['input'];
};


export type MutationApproveCrewMemberArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationAssignVesselArgs = {
  expeditionId: Scalars['ID']['input'];
  role?: InputMaybe<VesselRole>;
  vesselId: Scalars['ID']['input'];
};


export type MutationAwardSailingMilesArgs = {
  expeditionId: Scalars['ID']['input'];
  input: AwardSailingMilesInput;
};


export type MutationCancelBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmUserDocumentUploadArgs = {
  documentId: Scalars['ID']['input'];
  documentUrl: Scalars['String']['input'];
  r2Key: Scalars['String']['input'];
};


export type MutationCreateCharterListingArgs = {
  input: CreateCharterListingInput;
  orgId: Scalars['ID']['input'];
  vesselId: Scalars['ID']['input'];
};


export type MutationCreateCourseArgs = {
  input: CreateCourseInput;
  orgId: Scalars['ID']['input'];
};


export type MutationCreateExpeditionArgs = {
  input: CreateExpeditionInput;
  orgId: Scalars['ID']['input'];
};


export type MutationCreateOrganisationArgs = {
  input: CreateOrganisationInput;
};


export type MutationCreateRouteArgs = {
  input: CreateRouteInput;
  orgId: Scalars['ID']['input'];
};


export type MutationCreateSkillArgs = {
  categoryId: Scalars['ID']['input'];
  input: CreateSkillInput;
  orgId: Scalars['ID']['input'];
};


export type MutationCreateSkillCategoryArgs = {
  input: CreateSkillCategoryInput;
  orgId: Scalars['ID']['input'];
};


export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
  orgId: Scalars['ID']['input'];
};


export type MutationCreateVesselArgs = {
  input: CreateVesselInput;
  orgId: Scalars['ID']['input'];
};


export type MutationCreateVesselDocumentArgs = {
  input: CreateVesselDocumentInput;
  vesselId: Scalars['ID']['input'];
};


export type MutationCreateVesselMaintenanceLogArgs = {
  input: CreateVesselMaintenanceLogInput;
  vesselId: Scalars['ID']['input'];
};


export type MutationDeclineCrewMemberArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationDeleteCharterListingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCourseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLogbookEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRouteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSkillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSkillAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSkillCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSurveyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVesselArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVesselDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVesselPhotoArgs = {
  photoId: Scalars['ID']['input'];
};


export type MutationEnrolUserArgs = {
  courseId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationGenerateOrgLogoUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationGenerateVesselDocumentUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  vesselId: Scalars['ID']['input'];
};


export type MutationGenerateVesselUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  vesselId: Scalars['ID']['input'];
};


export type MutationImportSkillTemplateArgs = {
  orgId: Scalars['ID']['input'];
  templateKey: Scalars['String']['input'];
};


export type MutationInviteCrewArgs = {
  expeditionId: Scalars['ID']['input'];
  input: InviteCrewInput;
};


export type MutationInviteMemberArgs = {
  input: InviteMemberInput;
  orgId: Scalars['ID']['input'];
};


export type MutationIssueCertificateArgs = {
  input: IssueCertificateInput;
};


export type MutationJoinExpeditionArgs = {
  expeditionId: Scalars['ID']['input'];
  input: JoinExpeditionInput;
};


export type MutationLeaveExpeditionArgs = {
  expeditionId: Scalars['ID']['input'];
};


export type MutationMarkDisembarkedEarlyArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationMarkNoShowArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationMarkNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPresignUserDocumentUploadArgs = {
  contentType: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationRecordAssessmentArgs = {
  enrolmentId: Scalars['ID']['input'];
  input: RecordAssessmentInput;
};


export type MutationRecordExpenseArgs = {
  expeditionId: Scalars['ID']['input'];
  input: RecordExpenseInput;
};


export type MutationRecordSettlementArgs = {
  expeditionId: Scalars['ID']['input'];
  input: RecordSettlementInput;
};


export type MutationRecordSkillAssessmentArgs = {
  input: RecordSkillAssessmentInput;
  orgId: Scalars['ID']['input'];
};


export type MutationRecordVesselPingArgs = {
  input: RecordVesselPingInput;
};


export type MutationRegenerateCertificatePdfArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegisterDocumentArgs = {
  input: RegisterDocumentInput;
  orgId: Scalars['ID']['input'];
};


export type MutationReinstateCrewMemberArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationRemoveCrewMemberArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationRemoveMemberArgs = {
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveSkillLevelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveVesselArgs = {
  expeditionVesselId: Scalars['ID']['input'];
};


export type MutationRemoveWaypointArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReorderWaypointsArgs = {
  routeId: Scalars['ID']['input'];
  waypointIds: Array<Scalars['ID']['input']>;
};


export type MutationRequestBookingArgs = {
  input: BookingRequestInput;
  listingId: Scalars['ID']['input'];
};


export type MutationRequestDocumentVerificationArgs = {
  documentId: Scalars['ID']['input'];
  expeditionId: Scalars['ID']['input'];
};


export type MutationRequestUploadArgs = {
  input: UploadRequestInput;
  orgId: Scalars['ID']['input'];
};


export type MutationRevokeCertificateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendTestNotificationArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetCrewVesselArgs = {
  membershipId: Scalars['ID']['input'];
  vesselId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetVesselCoverPhotoArgs = {
  photoId: Scalars['ID']['input'];
};


export type MutationSettleExpenseArgs = {
  expeditionId: Scalars['ID']['input'];
  input: SettleExpenseInput;
};


export type MutationSubmitReviewArgs = {
  bookingId: Scalars['ID']['input'];
  input: ReviewInput;
};


export type MutationUpdateCharterListingArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCharterListingInput;
};


export type MutationUpdateCourseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCourseInput;
};


export type MutationUpdateCrewMembershipRoleArgs = {
  membershipId: Scalars['ID']['input'];
  role: CrewRole;
};


export type MutationUpdateEnrolmentStatusArgs = {
  id: Scalars['ID']['input'];
  status: EnrolmentStatus;
};


export type MutationUpdateExpeditionStatusArgs = {
  id: Scalars['ID']['input'];
  status: ExpeditionStatus;
};


export type MutationUpdateMemberRolesArgs = {
  orgId: Scalars['ID']['input'];
  roles: Array<OrgRole>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateOrgPreferencesArgs = {
  input: UpdateOrgPreferencesInput;
  orgId: Scalars['ID']['input'];
};


export type MutationUpdateOrganisationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationInput;
};


export type MutationUpdateRouteArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRouteInput;
};


export type MutationUpdateSkillArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSkillInput;
};


export type MutationUpdateSkillCategoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSkillCategoryInput;
};


export type MutationUpdateSkillLevelArgs = {
  id: Scalars['ID']['input'];
  input: SkillLevelInput;
};


export type MutationUpdateSurveyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSurveyInput;
};


export type MutationUpdateUserDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserDocumentInput;
};


export type MutationUpdateVesselArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVesselInput;
};


export type MutationUpdateVesselMaintenanceLogArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVesselMaintenanceLogInput;
};


export type MutationUpdateVesselStatusArgs = {
  id: Scalars['ID']['input'];
  status: VesselStatus;
};


export type MutationUpsertExpensePolicyArgs = {
  input: UpsertExpensePolicyInput;
  orgId: Scalars['ID']['input'];
};


export type MutationVerifyUserDocumentArgs = {
  documentId: Scalars['ID']['input'];
  expeditionId?: InputMaybe<Scalars['ID']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  body: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  organisation?: Maybe<Organization>;
  readAt?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  user: User;
};

export type OrgPreferences = {
  __typename?: 'OrgPreferences';
  autoIssueCerts: Scalars['Boolean']['output'];
  publicCrewProfiles: Scalars['Boolean']['output'];
  requireInstructorApproval: Scalars['Boolean']['output'];
  surveyReminders: Scalars['Boolean']['output'];
};

export const OrgRole = {
  Admin: 'ADMIN',
  Crew: 'CREW',
  Instructor: 'INSTRUCTOR',
  Observer: 'OBSERVER',
  Owner: 'OWNER',
  Skipper: 'SKIPPER',
  Student: 'STUDENT'
} as const;

export type OrgRole = typeof OrgRole[keyof typeof OrgRole];
export const OrgType = {
  Both: 'BOTH',
  CharterCompany: 'CHARTER_COMPANY',
  ExpeditionOrganizer: 'EXPEDITION_ORGANIZER',
  School: 'SCHOOL'
} as const;

export type OrgType = typeof OrgType[keyof typeof OrgType];
export type Organization = {
  __typename?: 'Organization';
  courses: Array<Course>;
  createdAt: Scalars['DateTime']['output'];
  expeditions: Array<Expedition>;
  homePort?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitations: Array<Invitation>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  members: Array<OrganizationMembership>;
  name: Scalars['String']['output'];
  orgType?: Maybe<OrgType>;
  preferences: OrgPreferences;
  routes: Array<Route>;
  skillCategories: Array<SkillCategory>;
  skills: Array<Skill>;
  slug: Scalars['String']['output'];
  surveys: Array<Survey>;
  updatedAt: Scalars['DateTime']['output'];
  vessels: Array<Vessel>;
};

export type OrganizationMembership = {
  __typename?: 'OrganizationMembership';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organisation: Organization;
  roles: Array<OrgRole>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type PersonExpenseSummary = {
  __typename?: 'PersonExpenseSummary';
  netCents: Scalars['Int']['output'];
  totalOwedCents: Scalars['Int']['output'];
  totalOwesToCents: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

export type Query = {
  __typename?: 'Query';
  _certsHealth?: Maybe<Scalars['String']['output']>;
  _charterHealth?: Maybe<Scalars['String']['output']>;
  _expeditionsHealth?: Maybe<Scalars['String']['output']>;
  _notificationsHealth?: Maybe<Scalars['String']['output']>;
  _platformHealth?: Maybe<Scalars['String']['output']>;
  _schoolHealth?: Maybe<Scalars['String']['output']>;
  _trackingHealth?: Maybe<Scalars['String']['output']>;
  assessments: Array<Assessment>;
  certificate?: Maybe<Certificate>;
  certificates: Array<Certificate>;
  charterBooking?: Maybe<CharterBooking>;
  charterBookings: Array<CharterBooking>;
  charterListing?: Maybe<CharterListing>;
  charterListings: Array<CharterListing>;
  course?: Maybe<Course>;
  courses: Array<Course>;
  crewAssessments: Array<SkillAssessment>;
  document?: Maybe<Document>;
  documents: Array<Document>;
  enrolment?: Maybe<Enrolment>;
  expedition?: Maybe<Expedition>;
  expeditionBySlug?: Maybe<Expedition>;
  expeditions: Array<Expedition>;
  expensePolicy?: Maybe<ExpensePolicy>;
  expenseSummary: ExpenseSummary;
  expenses: Array<Expense>;
  logbookEntries: Array<LogbookEntry>;
  me?: Maybe<User>;
  myCertificates: Array<Certificate>;
  myCharterBookings: Array<CharterBooking>;
  /** Returns the current user's own documents. */
  myDocuments: Array<UserDocument>;
  myEnrolments: Array<Enrolment>;
  myMemberships: Array<OrganizationMembership>;
  myNotifications: Array<Notification>;
  organisation?: Maybe<Organization>;
  organisations: Array<Organization>;
  route?: Maybe<Route>;
  routeVersion?: Maybe<RouteVersion>;
  routes: Array<Route>;
  skill?: Maybe<Skill>;
  skillAssessments: Array<SkillAssessment>;
  skillCategories: Array<SkillCategory>;
  skillCategory?: Maybe<SkillCategory>;
  skillTemplates: Array<SkillTemplate>;
  skills: Array<Skill>;
  survey?: Maybe<Survey>;
  surveys: Array<Survey>;
  unreadCount: Scalars['Int']['output'];
  user?: Maybe<User>;
  /** Returns a single document if the caller has visibility on it. */
  userDocument?: Maybe<UserDocument>;
  /** Returns documents for a given user, filtered by the caller's visibility relationship. */
  userDocuments: Array<UserDocument>;
  userMilesAwards: Array<SailingMilesAward>;
  vessel?: Maybe<Vessel>;
  vesselBySlug?: Maybe<Vessel>;
  /** Returns all documents attached to a vessel. Any org member may call this. */
  vesselDocuments: Array<VesselDocument>;
  /** Returns the maintenance log for a vessel. Any org member may call this. */
  vesselMaintenanceLogs: Array<VesselMaintenanceLog>;
  vessels: Array<Vessel>;
};


export type QueryAssessmentsArgs = {
  enrolmentId: Scalars['ID']['input'];
};


export type QueryCertificateArgs = {
  verificationCode: Scalars['String']['input'];
};


export type QueryCertificatesArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryCharterBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCharterBookingsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryCharterListingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCharterListingsArgs = {
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCourseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoursesArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryCrewAssessmentsArgs = {
  crewMembershipId: Scalars['ID']['input'];
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryEnrolmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpeditionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpeditionBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryExpeditionsArgs = {
  orgId: Scalars['ID']['input'];
  status?: InputMaybe<ExpeditionStatus>;
};


export type QueryExpensePolicyArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryExpenseSummaryArgs = {
  expeditionId: Scalars['ID']['input'];
};


export type QueryExpensesArgs = {
  expeditionId: Scalars['ID']['input'];
};


export type QueryLogbookEntriesArgs = {
  expeditionId: Scalars['ID']['input'];
};


export type QueryMyNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRouteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRouteVersionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRoutesArgs = {
  orgId: Scalars['ID']['input'];
};


export type QuerySkillArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySkillAssessmentsArgs = {
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QuerySkillCategoriesArgs = {
  orgId: Scalars['ID']['input'];
};


export type QuerySkillCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySkillsArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QuerySurveyArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySurveysArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserDocumentsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserMilesAwardsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryVesselArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVesselBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryVesselDocumentsArgs = {
  vesselId: Scalars['ID']['input'];
};


export type QueryVesselMaintenanceLogsArgs = {
  vesselId: Scalars['ID']['input'];
};


export type QueryVesselsArgs = {
  orgId: Scalars['ID']['input'];
  source?: InputMaybe<VesselSource>;
  status?: InputMaybe<VesselStatus>;
};

export const RatingSystem = {
  Custom: 'CUSTOM',
  LetterGrade: 'LETTER_GRADE',
  Numeric: 'NUMERIC',
  PassFail: 'PASS_FAIL'
} as const;

export type RatingSystem = typeof RatingSystem[keyof typeof RatingSystem];
export type RecordAssessmentInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  numericValue?: InputMaybe<Scalars['Float']['input']>;
  passed: Scalars['Boolean']['input'];
  ratingValue: Scalars['String']['input'];
  skillId: Scalars['ID']['input'];
};

export type RecordExpenseInput = {
  amountCents: Scalars['Int']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
};

export type RecordSettlementInput = {
  amountCents: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  settledWithUserId: Scalars['ID']['input'];
};

export type RecordSkillAssessmentInput = {
  assessedUserId: Scalars['ID']['input'];
  crewMembershipId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numericValue?: InputMaybe<Scalars['Float']['input']>;
  passed?: InputMaybe<Scalars['Boolean']['input']>;
  ratingValue: Scalars['String']['input'];
  skillId: Scalars['ID']['input'];
};

export type RecordVesselPingInput = {
  altitudeM?: InputMaybe<Scalars['Float']['input']>;
  expeditionId: Scalars['ID']['input'];
  heading?: InputMaybe<Scalars['Float']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  speedKnots?: InputMaybe<Scalars['Float']['input']>;
  vesselId: Scalars['ID']['input'];
};

export type RegisterDocumentInput = {
  fileKey: Scalars['String']['input'];
  fileSizeBytes: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type Review = {
  __typename?: 'Review';
  booking: CharterBooking;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
  reviewer: User;
};

export type ReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};

export type Route = {
  __typename?: 'Route';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organization;
  totalDistanceNm?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  waypoints: Array<RouteWaypoint>;
};

export type RouteVersion = {
  __typename?: 'RouteVersion';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  route: Route;
  waypoints: Array<RouteWaypoint>;
};

export type RouteWaypoint = {
  __typename?: 'RouteWaypoint';
  estimatedLegHours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orderIndex: Scalars['Int']['output'];
  plannedArrival?: Maybe<Scalars['DateTime']['output']>;
};

export type SailingMilesAward = {
  __typename?: 'SailingMilesAward';
  awardedAt: Scalars['DateTime']['output'];
  crewRole: Scalars['String']['output'];
  expeditionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  miles: Scalars['Float']['output'];
  userId: Scalars['ID']['output'];
};

export type SailingMilesSummary = {
  __typename?: 'SailingMilesSummary';
  expeditionCount: Scalars['Int']['output'];
  totalMiles: Scalars['Float']['output'];
};

export const SeaState = {
  Calm: 'CALM',
  High: 'HIGH',
  Moderate: 'MODERATE',
  Rough: 'ROUGH',
  Slight: 'SLIGHT',
  VeryRough: 'VERY_ROUGH'
} as const;

export type SeaState = typeof SeaState[keyof typeof SeaState];
export type SettleExpenseInput = {
  expenseId: Scalars['ID']['input'];
};

export type Settlement = {
  __typename?: 'Settlement';
  amountCents: Scalars['Int']['output'];
  expedition: Expedition;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  settledAt: Scalars['DateTime']['output'];
  settledBy: User;
  settledWith: User;
};

export type Skill = {
  __typename?: 'Skill';
  category: SkillCategory;
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<SkillLevelTier>;
  levels: Array<SkillLevel>;
  name: Scalars['String']['output'];
  organisation: Organization;
  ratingSystem: RatingSystem;
};

export type SkillAssessment = {
  __typename?: 'SkillAssessment';
  assessedAt: Scalars['String']['output'];
  assessedUser: User;
  assessor: User;
  crewMembership?: Maybe<CrewMembership>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  numericValue?: Maybe<Scalars['Float']['output']>;
  passed: Scalars['Boolean']['output'];
  ratingValue: Scalars['String']['output'];
  skill: Skill;
};

export type SkillCategory = {
  __typename?: 'SkillCategory';
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organization;
  skills: Array<Skill>;
  sortOrder: Scalars['Int']['output'];
};

export type SkillLevel = {
  __typename?: 'SkillLevel';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  numericValue?: Maybe<Scalars['Float']['output']>;
  skill: Skill;
  sortOrder: Scalars['Int']['output'];
};

export type SkillLevelInput = {
  label: Scalars['String']['input'];
  numericValue?: InputMaybe<Scalars['Float']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export const SkillLevelTier = {
  Coastal: 'COASTAL',
  Inshore: 'INSHORE',
  Ocean: 'OCEAN',
  Offshore: 'OFFSHORE',
  Professional: 'PROFESSIONAL'
} as const;

export type SkillLevelTier = typeof SkillLevelTier[keyof typeof SkillLevelTier];
export type SkillTemplate = {
  __typename?: 'SkillTemplate';
  /** Summary of categories in this template (name + skill count). */
  categories: Array<SkillTemplateCategoryPreview>;
  description?: Maybe<Scalars['String']['output']>;
  dominantLevel?: Maybe<SkillLevelTier>;
  framework?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Total number of skills across all categories in this template. */
  skillCount: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type SkillTemplateCategoryPreview = {
  __typename?: 'SkillTemplateCategoryPreview';
  name: Scalars['String']['output'];
  skillCount: Scalars['Int']['output'];
  skills: Array<SkillTemplateSkillPreview>;
};

export type SkillTemplateSkillPreview = {
  __typename?: 'SkillTemplateSkillPreview';
  name: Scalars['String']['output'];
  ratingSystem: RatingSystem;
};

export type Subscription = {
  __typename?: 'Subscription';
  certPdfReady: Certificate;
  notificationReceived: Notification;
  vesselPings: VesselPing;
};


export type SubscriptionCertPdfReadyArgs = {
  certId: Scalars['ID']['input'];
};


export type SubscriptionVesselPingsArgs = {
  expeditionId: Scalars['ID']['input'];
};

export type Survey = {
  __typename?: 'Survey';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  organisation: Organization;
  questions: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UpdateCharterListingInput = {
  availableFrom?: InputMaybe<Scalars['String']['input']>;
  availableTo?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  maxGuests?: InputMaybe<Scalars['Int']['input']>;
  pricePerDayUsd?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<CharterListingStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCourseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrgPreferencesInput = {
  autoIssueCerts?: InputMaybe<Scalars['Boolean']['input']>;
  publicCrewProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  requireInstructorApproval?: InputMaybe<Scalars['Boolean']['input']>;
  surveyReminders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrganisationInput = {
  homePort?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgType?: InputMaybe<OrgType>;
};

export type UpdateRouteInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSkillCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSkillInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<SkillLevelTier>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratingSystem?: InputMaybe<RatingSystem>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSurveyInput = {
  questions?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserDocumentInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  issuedAt?: InputMaybe<Scalars['DateTime']['input']>;
  issuingBody?: InputMaybe<Scalars['String']['input']>;
  issuingCountry?: InputMaybe<Scalars['String']['input']>;
  levelNotes?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVesselInput = {
  beamM?: InputMaybe<Scalars['Float']['input']>;
  berths?: InputMaybe<Scalars['Int']['input']>;
  callSign?: InputMaybe<Scalars['String']['input']>;
  charterCompanyContact?: InputMaybe<Scalars['String']['input']>;
  charterCompanyName?: InputMaybe<Scalars['String']['input']>;
  charterEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  charterStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  draftM?: InputMaybe<Scalars['Float']['input']>;
  enginePowerKw?: InputMaybe<Scalars['Float']['input']>;
  flagState?: InputMaybe<Scalars['String']['input']>;
  fuelCapacityL?: InputMaybe<Scalars['Float']['input']>;
  homePort?: InputMaybe<Scalars['String']['input']>;
  lengthM?: InputMaybe<Scalars['Float']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  maxPassengers?: InputMaybe<Scalars['Int']['input']>;
  mmsiNumber?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registration?: InputMaybe<Scalars['String']['input']>;
  vesselType?: InputMaybe<VesselType>;
  waterCapacityL?: InputMaybe<Scalars['Float']['input']>;
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateVesselMaintenanceLogInput = {
  engineHoursAtService?: InputMaybe<Scalars['Float']['input']>;
  expeditionId?: InputMaybe<Scalars['ID']['input']>;
  nextServiceDue?: InputMaybe<Scalars['DateTime']['input']>;
  nextServiceEngineHours?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partsReplaced?: InputMaybe<Scalars['String']['input']>;
  performedAt?: InputMaybe<Scalars['DateTime']['input']>;
  performedBy?: InputMaybe<Scalars['String']['input']>;
  workPerformed?: InputMaybe<Scalars['String']['input']>;
};

export type UploadCredentials = {
  __typename?: 'UploadCredentials';
  fileKey: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UploadRequestInput = {
  fileSizeBytes: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UploadUrl = {
  __typename?: 'UploadUrl';
  key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UpsertExpensePolicyInput = {
  approvalThresholdCents?: InputMaybe<Scalars['Int']['input']>;
  maxAmountCents?: InputMaybe<Scalars['Int']['input']>;
  requireReceipt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  __typename?: 'User';
  assessments: Array<Assessment>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  crewMemberships: Array<CrewMembership>;
  displayName: Scalars['String']['output'];
  documents: Array<UserDocument>;
  email: Scalars['String']['output'];
  enrolments: Array<Enrolment>;
  firstName: Scalars['String']['output'];
  homePort?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSuperAdmin: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  memberships: Array<OrganizationMembership>;
  notifications: Array<Notification>;
  sailingMiles?: Maybe<SailingMilesSummary>;
  skillAssessments: Array<SkillAssessment>;
  totalMilesLogged: Scalars['Float']['output'];
  unreadNotificationCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type UserNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserDocument = {
  __typename?: 'UserDocument';
  createdAt: Scalars['DateTime']['output'];
  documentType: Scalars['String']['output'];
  documentUrl?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isVerified: Scalars['Boolean']['output'];
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  issuingBody: Scalars['String']['output'];
  issuingCountry?: Maybe<Scalars['String']['output']>;
  levelNotes?: Maybe<Scalars['String']['output']>;
  r2Key?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedById?: Maybe<Scalars['ID']['output']>;
  verifiedInExpeditionId?: Maybe<Scalars['ID']['output']>;
  visibility: Scalars['String']['output'];
};

export type UserDocumentUploadUrl = {
  __typename?: 'UserDocumentUploadUrl';
  r2Key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type Vessel = {
  __typename?: 'Vessel';
  beamM?: Maybe<Scalars['Float']['output']>;
  berths?: Maybe<Scalars['Int']['output']>;
  callSign?: Maybe<Scalars['String']['output']>;
  charterCompanyContact?: Maybe<Scalars['String']['output']>;
  charterCompanyName?: Maybe<Scalars['String']['output']>;
  charterEndDate?: Maybe<Scalars['DateTime']['output']>;
  charterStartDate?: Maybe<Scalars['DateTime']['output']>;
  coverPhotoUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<VesselDocument>;
  draftM?: Maybe<Scalars['Float']['output']>;
  enginePowerKw?: Maybe<Scalars['Float']['output']>;
  expeditionAssignments: Array<ExpeditionVessel>;
  flagState?: Maybe<Scalars['String']['output']>;
  fuelCapacityL?: Maybe<Scalars['Float']['output']>;
  homePort?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lengthM?: Maybe<Scalars['Float']['output']>;
  maintenanceLogs: Array<VesselMaintenanceLog>;
  make?: Maybe<Scalars['String']['output']>;
  maxPassengers?: Maybe<Scalars['Int']['output']>;
  mmsiNumber?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisation: Organization;
  photos: Array<VesselPhoto>;
  registration?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  source: VesselSource;
  status: VesselStatus;
  updatedAt: Scalars['DateTime']['output'];
  vesselType?: Maybe<VesselType>;
  waterCapacityL?: Maybe<Scalars['Float']['output']>;
  yearBuilt?: Maybe<Scalars['Int']['output']>;
};

export const VesselDocType = {
  ClassCertificate: 'CLASS_CERTIFICATE',
  InspectionReport: 'INSPECTION_REPORT',
  Insurance: 'INSURANCE',
  Other: 'OTHER',
  RadioLicence: 'RADIO_LICENCE',
  Registration: 'REGISTRATION',
  SafetyCertificate: 'SAFETY_CERTIFICATE'
} as const;

export type VesselDocType = typeof VesselDocType[keyof typeof VesselDocType];
export type VesselDocument = {
  __typename?: 'VesselDocument';
  createdAt: Scalars['DateTime']['output'];
  docType: VesselDocType;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['ID']['output'];
  r2Key: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  vesselId: Scalars['ID']['output'];
};

export type VesselMaintenanceLog = {
  __typename?: 'VesselMaintenanceLog';
  createdAt: Scalars['DateTime']['output'];
  engineHoursAtService?: Maybe<Scalars['Float']['output']>;
  expeditionId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  nextServiceDue?: Maybe<Scalars['DateTime']['output']>;
  nextServiceEngineHours?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['ID']['output'];
  partsReplaced?: Maybe<Scalars['String']['output']>;
  performedAt: Scalars['DateTime']['output'];
  performedBy?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vesselId: Scalars['ID']['output'];
  workPerformed: Scalars['String']['output'];
};

export type VesselPhoto = {
  __typename?: 'VesselPhoto';
  caption?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isCover: Scalars['Boolean']['output'];
  r2Key: Scalars['String']['output'];
  /** File size in bytes; null for photos uploaded before this field was added */
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  sortOrder: Scalars['Int']['output'];
  /** Logical storage class for quota breakdowns (e.g. "vessel_photos") */
  storageClass: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  vesselId: Scalars['ID']['output'];
};

export type VesselPing = {
  __typename?: 'VesselPing';
  altitudeM?: Maybe<Scalars['Float']['output']>;
  expeditionId: Scalars['ID']['output'];
  heading?: Maybe<Scalars['Float']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  speedKnots?: Maybe<Scalars['Float']['output']>;
  time: Scalars['String']['output'];
  vesselId: Scalars['ID']['output'];
};

export const VesselRole = {
  Charter: 'CHARTER',
  LeadVessel: 'LEAD_VESSEL',
  Safety: 'SAFETY',
  Support: 'SUPPORT'
} as const;

export type VesselRole = typeof VesselRole[keyof typeof VesselRole];
export const VesselSource = {
  ExternalCharter: 'EXTERNAL_CHARTER',
  Owned: 'OWNED'
} as const;

export type VesselSource = typeof VesselSource[keyof typeof VesselSource];
export const VesselStatus = {
  Active: 'ACTIVE',
  Retired: 'RETIRED',
  UnderMaintenance: 'UNDER_MAINTENANCE'
} as const;

export type VesselStatus = typeof VesselStatus[keyof typeof VesselStatus];
export const VesselType = {
  Catamaran: 'CATAMARAN',
  Dinghy: 'DINGHY',
  Keelboat: 'KEELBOAT',
  Monohull: 'MONOHULL',
  MotorSailer: 'MOTOR_SAILER',
  Other: 'OTHER',
  Rib: 'RIB',
  TallShip: 'TALL_SHIP',
  Trimaran: 'TRIMARAN'
} as const;

export type VesselType = typeof VesselType[keyof typeof VesselType];
export type WaypointInput = {
  estimatedLegHours?: InputMaybe<Scalars['Float']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderIndex: Scalars['Int']['input'];
};

export const WindDirection = {
  E: 'E',
  N: 'N',
  Ne: 'NE',
  Nw: 'NW',
  S: 'S',
  Se: 'SE',
  Sw: 'SW',
  W: 'W'
} as const;

export type WindDirection = typeof WindDirection[keyof typeof WindDirection];
export type CertFieldsFragment = { __typename?: 'Certificate', id: string, title: string, description?: string | null | undefined, issuedAt: string, revokedAt?: string | null | undefined, verificationCode: string, pdfUrl?: string | null | undefined, issuedTo: { __typename?: 'User', id: string, displayName: string, email: string }, issuedBy: { __typename?: 'User', id: string, displayName: string }, expedition?: { __typename?: 'Expedition', id: string, name: string } | null | undefined, course?: { __typename?: 'Course', id: string, name: string } | null | undefined };

export type CertificatesListQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type CertificatesListQuery = { __typename?: 'Query', certificates: Array<{ __typename?: 'Certificate', id: string, title: string, description?: string | null | undefined, issuedAt: string, revokedAt?: string | null | undefined, verificationCode: string, pdfUrl?: string | null | undefined, issuedTo: { __typename?: 'User', id: string, displayName: string, email: string }, issuedBy: { __typename?: 'User', id: string, displayName: string }, expedition?: { __typename?: 'Expedition', id: string, name: string } | null | undefined, course?: { __typename?: 'Course', id: string, name: string } | null | undefined }> };

export type MyCertificatesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCertificatesQuery = { __typename?: 'Query', myCertificates: Array<{ __typename?: 'Certificate', id: string, title: string, description?: string | null | undefined, issuedAt: string, revokedAt?: string | null | undefined, verificationCode: string, pdfUrl?: string | null | undefined, issuedTo: { __typename?: 'User', id: string, displayName: string, email: string }, issuedBy: { __typename?: 'User', id: string, displayName: string }, expedition?: { __typename?: 'Expedition', id: string, name: string } | null | undefined, course?: { __typename?: 'Course', id: string, name: string } | null | undefined }> };

export type CertificateByCodeQueryVariables = Exact<{
  verificationCode: Scalars['String']['input'];
}>;


export type CertificateByCodeQuery = { __typename?: 'Query', certificate?: { __typename?: 'Certificate', id: string, pdfUrl?: string | null | undefined } | null | undefined };

export type IssueCertificateMutationVariables = Exact<{
  input: IssueCertificateInput;
}>;


export type IssueCertificateMutation = { __typename?: 'Mutation', issueCertificate: { __typename?: 'Certificate', id: string, title: string, description?: string | null | undefined, issuedAt: string, revokedAt?: string | null | undefined, verificationCode: string, pdfUrl?: string | null | undefined, issuedTo: { __typename?: 'User', id: string, displayName: string, email: string }, issuedBy: { __typename?: 'User', id: string, displayName: string }, expedition?: { __typename?: 'Expedition', id: string, name: string } | null | undefined, course?: { __typename?: 'Course', id: string, name: string } | null | undefined } };

export type RevokeCertificateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevokeCertificateMutation = { __typename?: 'Mutation', revokeCertificate: { __typename?: 'Certificate', id: string, revokedAt?: string | null | undefined } };

export type RegenerateCertificatePdfMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RegenerateCertificatePdfMutation = { __typename?: 'Mutation', regenerateCertificatePdf: { __typename?: 'Certificate', id: string, pdfUrl?: string | null | undefined } };

export type CertPdfReadySubscriptionVariables = Exact<{
  certId: Scalars['ID']['input'];
}>;


export type CertPdfReadySubscription = { __typename?: 'Subscription', certPdfReady: { __typename?: 'Certificate', id: string, pdfUrl?: string | null | undefined } };

export type CharterListingsListQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type CharterListingsListQuery = { __typename?: 'Query', charterListings: Array<{ __typename?: 'CharterListing', id: string, title: string, description?: string | null | undefined, status: CharterListingStatus, pricePerDayUsd: number, maxGuests: number, availableFrom: string, availableTo: string, createdAt: string, vessel: { __typename?: 'Vessel', id: string, name: string, vesselType?: VesselType | null | undefined } }> };

export type CharterBookingsListQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type CharterBookingsListQuery = { __typename?: 'Query', charterBookings: Array<{ __typename?: 'CharterBooking', id: string, status: BookingStatus, startDate: string, endDate: string, totalPriceUsd: number, createdAt: string, listing: { __typename?: 'CharterListing', id: string, title: string, vessel: { __typename?: 'Vessel', id: string, name: string } }, guest: { __typename?: 'User', id: string, displayName: string, email: string } }> };

export type CreateCharterListingMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  vesselId: Scalars['ID']['input'];
  input: CreateCharterListingInput;
}>;


export type CreateCharterListingMutation = { __typename?: 'Mutation', createCharterListing: { __typename?: 'CharterListing', id: string, title: string, status: CharterListingStatus, pricePerDayUsd: number, availableFrom: string, availableTo: string } };

export type UpdateCharterListingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCharterListingInput;
}>;


export type UpdateCharterListingMutation = { __typename?: 'Mutation', updateCharterListing: { __typename?: 'CharterListing', id: string, title: string, status: CharterListingStatus, pricePerDayUsd: number } };

export type DeleteCharterListingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCharterListingMutation = { __typename?: 'Mutation', deleteCharterListing: { __typename?: 'CharterListing', id: string } };

export type ConfirmBookingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConfirmBookingMutation = { __typename?: 'Mutation', confirmBooking: { __typename?: 'CharterBooking', id: string, status: BookingStatus } };

export type CancelBookingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelBookingMutation = { __typename?: 'Mutation', cancelBooking: { __typename?: 'CharterBooking', id: string, status: BookingStatus } };

export type ProfileUserDocumentFieldsFragment = { __typename?: 'UserDocument', id: string, documentType: string, title: string, issuingBody: string, issuingCountry?: string | null | undefined, referenceNumber?: string | null | undefined, issuedAt?: string | null | undefined, expiresAt?: string | null | undefined, documentUrl?: string | null | undefined, visibility: string, isVerified: boolean, verifiedAt?: string | null | undefined };

export type ProfileSkillAssessmentFieldsFragment = { __typename?: 'SkillAssessment', id: string, ratingValue: string, numericValue?: number | null | undefined, passed: boolean, notes?: string | null | undefined, assessedAt: string, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, ratingSystem: RatingSystem, category: { __typename?: 'SkillCategory', id: string, name: string } }, assessor: { __typename?: 'User', id: string, displayName: string, avatarUrl?: string | null | undefined }, crewMembership?: { __typename?: 'CrewMembership', id: string, expedition: { __typename?: 'Expedition', id: string, slug: string, name: string } } | null | undefined };

export type ProfileCrewMembershipFieldsFragment = { __typename?: 'CrewMembership', id: string, role: CrewRole, joinType: CrewJoinType, status: CrewMembershipStatus, joinedAt?: string | null | undefined, expedition: { __typename?: 'Expedition', id: string, slug: string, name: string, status: ExpeditionStatus, departureDate?: string | null | undefined, returnDate?: string | null | undefined } };

export type CrewProfileQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type CrewProfileQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, displayName: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null | undefined, bio?: string | null | undefined, homePort?: string | null | undefined, totalMilesLogged: number, memberships: Array<{ __typename?: 'OrganizationMembership', id: string, roles: Array<OrgRole>, createdAt: string, organisation: { __typename?: 'Organization', id: string, name: string } }>, sailingMiles?: { __typename?: 'SailingMilesSummary', totalMiles: number, expeditionCount: number } | null | undefined, crewMemberships: Array<{ __typename?: 'CrewMembership', id: string, role: CrewRole, joinType: CrewJoinType, status: CrewMembershipStatus, joinedAt?: string | null | undefined, expedition: { __typename?: 'Expedition', id: string, slug: string, name: string, status: ExpeditionStatus, departureDate?: string | null | undefined, returnDate?: string | null | undefined } }>, skillAssessments: Array<{ __typename?: 'SkillAssessment', id: string, ratingValue: string, numericValue?: number | null | undefined, passed: boolean, notes?: string | null | undefined, assessedAt: string, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, ratingSystem: RatingSystem, category: { __typename?: 'SkillCategory', id: string, name: string } }, assessor: { __typename?: 'User', id: string, displayName: string, avatarUrl?: string | null | undefined }, crewMembership?: { __typename?: 'CrewMembership', id: string, expedition: { __typename?: 'Expedition', id: string, slug: string, name: string } } | null | undefined }> } | null | undefined };

export type CrewProfileDocumentsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type CrewProfileDocumentsQuery = { __typename?: 'Query', userDocuments: Array<{ __typename?: 'UserDocument', id: string, documentType: string, title: string, issuingBody: string, issuingCountry?: string | null | undefined, referenceNumber?: string | null | undefined, issuedAt?: string | null | undefined, expiresAt?: string | null | undefined, documentUrl?: string | null | undefined, visibility: string, isVerified: boolean, verifiedAt?: string | null | undefined }> };

export type CrewProfileCertificatesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type CrewProfileCertificatesQuery = { __typename?: 'Query', certificates: Array<{ __typename?: 'Certificate', id: string, title: string, description?: string | null | undefined, issuedAt: string, revokedAt?: string | null | undefined, verificationCode: string, pdfUrl?: string | null | undefined, issuedTo: { __typename?: 'User', id: string }, expedition?: { __typename?: 'Expedition', id: string, name: string } | null | undefined, course?: { __typename?: 'Course', id: string, name: string } | null | undefined }> };

export type CrewProfileMilesAwardsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type CrewProfileMilesAwardsQuery = { __typename?: 'Query', userMilesAwards: Array<{ __typename?: 'SailingMilesAward', id: string, userId: string, expeditionId: string, miles: number, crewRole: string, awardedAt: string }> };

export type OrgCrewListQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type OrgCrewListQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organization', id: string, members: Array<{ __typename?: 'OrganizationMembership', id: string, roles: Array<OrgRole>, createdAt: string, user: { __typename?: 'User', id: string, displayName: string, firstName: string, lastName: string, avatarUrl?: string | null | undefined, totalMilesLogged: number, crewMemberships: Array<{ __typename?: 'CrewMembership', id: string, status: CrewMembershipStatus, expedition: { __typename?: 'Expedition', id: string, name: string, status: ExpeditionStatus } }> } }> } | null | undefined };

export type OrgMembersQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type OrgMembersQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organization', id: string, name: string, members: Array<{ __typename?: 'OrganizationMembership', id: string, roles: Array<OrgRole>, createdAt: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, displayName: string, avatarUrl?: string | null | undefined } }>, invitations: Array<{ __typename?: 'Invitation', id: string, email: string, roles: Array<OrgRole>, status: InvitationStatus, expiresAt: string }> } | null | undefined };

export type InviteMemberMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  input: InviteMemberInput;
}>;


export type InviteMemberMutation = { __typename?: 'Mutation', inviteMember: { __typename?: 'Invitation', id: string, email: string, roles: Array<OrgRole>, status: InvitationStatus, expiresAt: string } };

export type UpdateMemberRolesMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  roles: Array<OrgRole> | OrgRole;
}>;


export type UpdateMemberRolesMutation = { __typename?: 'Mutation', updateMemberRoles: { __typename?: 'OrganizationMembership', id: string, roles: Array<OrgRole>, user: { __typename?: 'User', id: string, displayName: string } } };

export type RemoveMemberMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveMemberMutation = { __typename?: 'Mutation', removeMember: boolean };

export type DashboardExpeditionsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type DashboardExpeditionsQuery = { __typename?: 'Query', activeExpeditions: Array<{ __typename?: 'Expedition', id: string, slug: string, name: string, status: ExpeditionStatus, departureDate?: string | null | undefined, returnDate?: string | null | undefined, maxCrew: number, route?: { __typename?: 'Route', id: string, name: string, totalDistanceNm?: number | null | undefined } | null | undefined, vessels: Array<{ __typename?: 'ExpeditionVessel', id: string, vessel: { __typename?: 'Vessel', id: string, name: string } }>, crew: Array<{ __typename?: 'CrewMembership', id: string, role: CrewRole, status: CrewMembershipStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, displayName: string, avatarUrl?: string | null | undefined } }> }>, openExpeditions: Array<{ __typename?: 'Expedition', id: string, slug: string, name: string, departureDate?: string | null | undefined, returnDate?: string | null | undefined, maxCrew: number, route?: { __typename?: 'Route', id: string, name: string, totalDistanceNm?: number | null | undefined } | null | undefined, crew: Array<{ __typename?: 'CrewMembership', id: string, status: CrewMembershipStatus }> }> };

export type DashboardOrgQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type DashboardOrgQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organization', id: string, name: string, members: Array<{ __typename?: 'OrganizationMembership', id: string, roles: Array<OrgRole>, user: { __typename?: 'User', id: string, displayName: string, avatarUrl?: string | null | undefined } }>, invitations: Array<{ __typename?: 'Invitation', id: string, email: string, status: InvitationStatus }> } | null | undefined, vessels: Array<{ __typename?: 'Vessel', id: string, slug: string, name: string, status: VesselStatus, homePort?: string | null | undefined, expeditionAssignments: Array<{ __typename?: 'ExpeditionVessel', id: string, expedition: { __typename?: 'Expedition', id: string, name: string, status: ExpeditionStatus } }> }> };

export type DashboardMeQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstName: string, lastName: string, displayName: string, avatarUrl?: string | null | undefined, totalMilesLogged: number, sailingMiles?: { __typename?: 'SailingMilesSummary', totalMiles: number, expeditionCount: number } | null | undefined } | null | undefined, myCertificates: Array<{ __typename?: 'Certificate', id: string }> };

export type UserDocumentFieldsFragment = { __typename?: 'UserDocument', id: string, userId: string, documentType: string, title: string, issuingBody: string, issuingCountry?: string | null | undefined, referenceNumber?: string | null | undefined, issuedAt?: string | null | undefined, expiresAt?: string | null | undefined, documentUrl?: string | null | undefined, levelNotes?: string | null | undefined, visibility: string, isVerified: boolean, verifiedAt?: string | null | undefined, createdAt: string, updatedAt: string };

export type VesselDocumentFieldsFragment = { __typename?: 'VesselDocument', id: string, vesselId: string, docType: VesselDocType, title: string, url: string, issuedAt?: string | null | undefined, expiresAt?: string | null | undefined, notes?: string | null | undefined, createdAt: string };

export type MyDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDocumentsQuery = { __typename?: 'Query', myDocuments: Array<{ __typename?: 'UserDocument', id: string, userId: string, documentType: string, title: string, issuingBody: string, issuingCountry?: string | null | undefined, referenceNumber?: string | null | undefined, issuedAt?: string | null | undefined, expiresAt?: string | null | undefined, documentUrl?: string | null | undefined, levelNotes?: string | null | undefined, visibility: string, isVerified: boolean, verifiedAt?: string | null | undefined, createdAt: string, updatedAt: string }> };

export type UserDocumentsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserDocumentsQuery = { __typename?: 'Query', userDocuments: Array<{ __typename?: 'UserDocument', id: string, userId: string, documentType: string, title: string, issuingBody: string, issuingCountry?: string | null | undefined, referenceNumber?: string | null | undefined, issuedAt?: string | null | undefined, expiresAt?: string | null | undefined, documentUrl?: string | null | undefined, levelNotes?: string | null | undefined, visibility: string, isVerified: boolean, verifiedAt?: string | null | undefined, createdAt: string, updatedAt: string }> };

export type AddUserDocumentMutationVariables = Exact<{
  input: AddUserDocumentInput;
}>;


export type AddUserDocumentMutation = { __typename?: 'Mutation', addUserDocument: { __typename?: 'UserDocument', id: string, userId: string, documentType: string, title: string, issuingBody: string, issuingCountry?: string | null | undefined, referenceNumber?: string | null | undefined, issuedAt?: string | null | undefined, expiresAt?: string | null | undefined, documentUrl?: string | null | undefined, levelNotes?: string | null | undefined, visibility: string, isVerified: boolean, verifiedAt?: string | null | undefined, createdAt: string, updatedAt: string } };

export type PresignUserDocumentUploadMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type PresignUserDocumentUploadMutation = { __typename?: 'Mutation', presignUserDocumentUpload: { __typename?: 'UserDocumentUploadUrl', uploadUrl: string, r2Key: string } };

export type ConfirmUserDocumentUploadMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  r2Key: Scalars['String']['input'];
  documentUrl: Scalars['String']['input'];
}>;


export type ConfirmUserDocumentUploadMutation = { __typename?: 'Mutation', confirmUserDocumentUpload: { __typename?: 'UserDocument', id: string, userId: string, documentType: string, title: string, issuingBody: string, issuingCountry?: string | null | undefined, referenceNumber?: string | null | undefined, issuedAt?: string | null | undefined, expiresAt?: string | null | undefined, documentUrl?: string | null | undefined, levelNotes?: string | null | undefined, visibility: string, isVerified: boolean, verifiedAt?: string | null | undefined, createdAt: string, updatedAt: string } };

export type DeleteUserDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserDocumentMutation = { __typename?: 'Mutation', deleteUserDocument: boolean };

export type RoutesListQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type RoutesListQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, name: string, description?: string | null | undefined, totalDistanceNm?: number | null | undefined, createdAt: string, updatedAt: string, waypoints: Array<{ __typename?: 'RouteWaypoint', id: string, name?: string | null | undefined, lat: number, lng: number, orderIndex: number }> }> };

export type RouteDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RouteDetailQuery = { __typename?: 'Query', route?: { __typename?: 'Route', id: string, name: string, description?: string | null | undefined, totalDistanceNm?: number | null | undefined, createdAt: string, updatedAt: string, waypoints: Array<{ __typename?: 'RouteWaypoint', id: string, name?: string | null | undefined, lat: number, lng: number, orderIndex: number }> } | null | undefined };

export type CreateRouteMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  input: CreateRouteInput;
}>;


export type CreateRouteMutation = { __typename?: 'Mutation', createRoute: { __typename?: 'Route', id: string, name: string, description?: string | null | undefined, totalDistanceNm?: number | null | undefined, waypoints: Array<{ __typename?: 'RouteWaypoint', id: string, name?: string | null | undefined, lat: number, lng: number, orderIndex: number }> } };

export type UpdateRouteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateRouteInput;
}>;


export type UpdateRouteMutation = { __typename?: 'Mutation', updateRoute: { __typename?: 'Route', id: string, name: string, description?: string | null | undefined } };

export type DeleteRouteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRouteMutation = { __typename?: 'Mutation', deleteRoute: boolean };

export type AddWaypointMutationVariables = Exact<{
  routeId: Scalars['ID']['input'];
  input: WaypointInput;
}>;


export type AddWaypointMutation = { __typename?: 'Mutation', addWaypoint: { __typename?: 'RouteWaypoint', id: string, name?: string | null | undefined, lat: number, lng: number, orderIndex: number } };

export type ReorderWaypointsMutationVariables = Exact<{
  routeId: Scalars['ID']['input'];
  waypointIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderWaypointsMutation = { __typename?: 'Mutation', reorderWaypoints: Array<{ __typename?: 'RouteWaypoint', id: string, orderIndex: number }> };

export type AssignVesselMutationVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
  vesselId: Scalars['ID']['input'];
  role?: InputMaybe<VesselRole>;
}>;


export type AssignVesselMutation = { __typename?: 'Mutation', assignVessel: { __typename?: 'ExpeditionVessel', id: string, role?: VesselRole | null | undefined, vessel: { __typename?: 'Vessel', id: string, name: string } } };

export type RemoveVesselMutationVariables = Exact<{
  expeditionVesselId: Scalars['ID']['input'];
}>;


export type RemoveVesselMutation = { __typename?: 'Mutation', removeVessel: boolean };

export type SetCrewVesselMutationVariables = Exact<{
  membershipId: Scalars['ID']['input'];
  vesselId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetCrewVesselMutation = { __typename?: 'Mutation', setCrewVessel: { __typename?: 'CrewMembership', id: string, vesselId?: string | null | undefined } };

export type ExpeditionsListQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  status?: InputMaybe<ExpeditionStatus>;
}>;


export type ExpeditionsListQuery = { __typename?: 'Query', expeditions: Array<{ __typename?: 'Expedition', id: string, slug: string, name: string, status: ExpeditionStatus, kind?: ExpeditionKind | null | undefined, departureDate?: string | null | undefined, returnDate?: string | null | undefined, maxCrew: number, route?: { __typename?: 'Route', id: string, name: string, totalDistanceNm?: number | null | undefined } | null | undefined, vessels: Array<{ __typename?: 'ExpeditionVessel', id: string, vessel: { __typename?: 'Vessel', id: string, name: string } }>, crew: Array<{ __typename?: 'CrewMembership', id: string, role: CrewRole, status: CrewMembershipStatus, joinType: CrewJoinType, user: { __typename?: 'User', id: string, displayName: string, firstName: string, lastName: string } }> }> };

export type ExpeditionDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExpeditionDetailQuery = { __typename?: 'Query', expedition?: { __typename?: 'Expedition', id: string, slug: string, name: string, status: ExpeditionStatus, departureDate?: string | null | undefined, returnDate?: string | null | undefined, maxCrew: number, route?: { __typename?: 'Route', id: string, name: string, description?: string | null | undefined, totalDistanceNm?: number | null | undefined, waypoints: Array<{ __typename?: 'RouteWaypoint', id: string, name?: string | null | undefined, lat: number, lng: number, orderIndex: number }> } | null | undefined, vessels: Array<{ __typename?: 'ExpeditionVessel', id: string, assignedAt: string, vessel: { __typename?: 'Vessel', id: string, name: string } }>, crew: Array<{ __typename?: 'CrewMembership', id: string, role: CrewRole, joinType: CrewJoinType, joinedAt?: string | null | undefined, user: { __typename?: 'User', id: string } }> } | null | undefined };

export type CreateExpeditionMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  input: CreateExpeditionInput;
}>;


export type CreateExpeditionMutation = { __typename?: 'Mutation', createExpedition: { __typename?: 'Expedition', id: string, slug: string, name: string, status: ExpeditionStatus, departureDate?: string | null | undefined, returnDate?: string | null | undefined, maxCrew: number } };

export type UpdateExpeditionStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: ExpeditionStatus;
}>;


export type UpdateExpeditionStatusMutation = { __typename?: 'Mutation', updateExpeditionStatus: { __typename?: 'Expedition', id: string, status: ExpeditionStatus } };

export type ExpeditionBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ExpeditionBySlugQuery = { __typename?: 'Query', expeditionBySlug?: { __typename?: 'Expedition', id: string, slug: string, name: string, status: ExpeditionStatus, kind?: ExpeditionKind | null | undefined, departureDate?: string | null | undefined, returnDate?: string | null | undefined, maxCrew: number, route?: { __typename?: 'Route', id: string, name: string, description?: string | null | undefined, totalDistanceNm?: number | null | undefined, waypoints: Array<{ __typename?: 'RouteWaypoint', id: string, name?: string | null | undefined, lat: number, lng: number, orderIndex: number, estimatedLegHours?: number | null | undefined, plannedArrival?: string | null | undefined }> } | null | undefined, vessels: Array<{ __typename?: 'ExpeditionVessel', id: string, role?: VesselRole | null | undefined, assignedAt: string, vessel: { __typename?: 'Vessel', id: string, name: string, vesselType?: VesselType | null | undefined, homePort?: string | null | undefined } }>, crew: Array<{ __typename?: 'CrewMembership', id: string, role: CrewRole, vesselId?: string | null | undefined, joinType: CrewJoinType, status: CrewMembershipStatus, joinedAt?: string | null | undefined, user: { __typename?: 'User', id: string, displayName: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null | undefined, totalMilesLogged: number } }> } | null | undefined };

export type ExpeditionExpensesQueryVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
}>;


export type ExpeditionExpensesQuery = { __typename?: 'Query', expenseSummary: { __typename?: 'ExpenseSummary', expeditionId: string, totalAmountCents: number, perPerson: Array<{ __typename?: 'PersonExpenseSummary', userId: string, totalOwedCents: number, totalOwesToCents: number, netCents: number }> } };

export type ExpeditionExpensesListQueryVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
}>;


export type ExpeditionExpensesListQuery = { __typename?: 'Query', expenses: Array<{ __typename?: 'Expense', id: string, description: string, amountCents: number, currency: string, receiptUrl?: string | null | undefined, createdAt: string, recordedBy: { __typename?: 'User', id: string, displayName: string, firstName: string, lastName: string, avatarUrl?: string | null | undefined }, splits: Array<{ __typename?: 'ExpenseSplit', id: string, amountCents: number, settledAt?: string | null | undefined, owedBy: { __typename?: 'User', id: string, displayName: string, firstName: string, lastName: string }, owedTo: { __typename?: 'User', id: string, displayName: string, firstName: string, lastName: string } }> }> };

export type RecordExpenseMutationVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
  input: RecordExpenseInput;
}>;


export type RecordExpenseMutation = { __typename?: 'Mutation', recordExpense: { __typename?: 'Expense', id: string, description: string, amountCents: number, currency: string, receiptUrl?: string | null | undefined, createdAt: string, recordedBy: { __typename?: 'User', id: string, displayName: string, firstName: string, lastName: string, avatarUrl?: string | null | undefined }, splits: Array<{ __typename?: 'ExpenseSplit', id: string, amountCents: number, settledAt?: string | null | undefined, owedBy: { __typename?: 'User', id: string, displayName: string, firstName: string, lastName: string }, owedTo: { __typename?: 'User', id: string, displayName: string, firstName: string, lastName: string } }> } };

export type DeleteExpenseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteExpenseMutation = { __typename?: 'Mutation', deleteExpense: boolean };

export type ApproveCrewMemberMutationVariables = Exact<{
  membershipId: Scalars['ID']['input'];
}>;


export type ApproveCrewMemberMutation = { __typename?: 'Mutation', approveCrewMember: { __typename?: 'CrewMembership', id: string, status: CrewMembershipStatus, role: CrewRole } };

export type DeclineCrewMemberMutationVariables = Exact<{
  membershipId: Scalars['ID']['input'];
}>;


export type DeclineCrewMemberMutation = { __typename?: 'Mutation', declineCrewMember: { __typename?: 'CrewMembership', id: string, status: CrewMembershipStatus } };

export type MarkNoShowMutationVariables = Exact<{
  membershipId: Scalars['ID']['input'];
}>;


export type MarkNoShowMutation = { __typename?: 'Mutation', markNoShow: { __typename?: 'CrewMembership', id: string, status: CrewMembershipStatus } };

export type MarkDisembarkedEarlyMutationVariables = Exact<{
  membershipId: Scalars['ID']['input'];
}>;


export type MarkDisembarkedEarlyMutation = { __typename?: 'Mutation', markDisembarkedEarly: { __typename?: 'CrewMembership', id: string, status: CrewMembershipStatus } };

export type ReinstateCrewMemberMutationVariables = Exact<{
  membershipId: Scalars['ID']['input'];
}>;


export type ReinstateCrewMemberMutation = { __typename?: 'Mutation', reinstateCrewMember: { __typename?: 'CrewMembership', id: string, status: CrewMembershipStatus } };

export type RemoveCrewMemberMutationVariables = Exact<{
  membershipId: Scalars['ID']['input'];
}>;


export type RemoveCrewMemberMutation = { __typename?: 'Mutation', removeCrewMember: boolean };

export type UpdateCrewMembershipRoleMutationVariables = Exact<{
  membershipId: Scalars['ID']['input'];
  role: CrewRole;
}>;


export type UpdateCrewMembershipRoleMutation = { __typename?: 'Mutation', updateCrewMembershipRole: { __typename?: 'CrewMembership', id: string, status: CrewMembershipStatus, role: CrewRole } };

export type LogbookEntriesQueryVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
}>;


export type LogbookEntriesQuery = { __typename?: 'Query', logbookEntries: Array<{ __typename?: 'LogbookEntry', id: string, entryTime: string, lat?: number | null | undefined, lng?: number | null | undefined, windSpeedKnots?: number | null | undefined, windDirection?: WindDirection | null | undefined, seaState?: SeaState | null | undefined, barometricPressure?: number | null | undefined, engineOn?: boolean | null | undefined, speedOverGround?: number | null | undefined, courseOverGround?: number | null | undefined, notes?: string | null | undefined, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string, displayName: string, avatarUrl?: string | null | undefined } }> };

export type AddLogbookEntryMutationVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
  input: AddLogbookEntryInput;
}>;


export type AddLogbookEntryMutation = { __typename?: 'Mutation', addLogbookEntry: { __typename?: 'LogbookEntry', id: string, entryTime: string, lat?: number | null | undefined, lng?: number | null | undefined, windSpeedKnots?: number | null | undefined, windDirection?: WindDirection | null | undefined, seaState?: SeaState | null | undefined, barometricPressure?: number | null | undefined, engineOn?: boolean | null | undefined, speedOverGround?: number | null | undefined, courseOverGround?: number | null | undefined, notes?: string | null | undefined, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string, displayName: string, avatarUrl?: string | null | undefined } } };

export type DeleteLogbookEntryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLogbookEntryMutation = { __typename?: 'Mutation', deleteLogbookEntry: boolean };

export type JoinExpeditionMutationVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
  input: JoinExpeditionInput;
}>;


export type JoinExpeditionMutation = { __typename?: 'Mutation', joinExpedition: { __typename?: 'CrewMembership', id: string, status: CrewMembershipStatus, role: CrewRole, joinType: CrewJoinType, joinedAt?: string | null | undefined, user: { __typename?: 'User', id: string } } };

export type LeaveExpeditionMutationVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
}>;


export type LeaveExpeditionMutation = { __typename?: 'Mutation', leaveExpedition: boolean };

export type InviteCrewMutationVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
  input: InviteCrewInput;
}>;


export type InviteCrewMutation = { __typename?: 'Mutation', inviteCrew: { __typename?: 'CrewMembership', id: string, status: CrewMembershipStatus, role: CrewRole, joinType: CrewJoinType, joinedAt?: string | null | undefined, user: { __typename?: 'User', id: string } } };

export type SettleExpenseMutationVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
  input: SettleExpenseInput;
}>;


export type SettleExpenseMutation = { __typename?: 'Mutation', settleExpense: { __typename?: 'ExpenseSplit', id: string, amountCents: number, settledAt?: string | null | undefined } };

export type RecordSettlementMutationVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
  input: RecordSettlementInput;
}>;


export type RecordSettlementMutation = { __typename?: 'Mutation', recordSettlement: { __typename?: 'Settlement', id: string, amountCents: number, settledAt: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, memberships: Array<{ __typename?: 'OrganizationMembership', id: string, roles: Array<OrgRole>, organisation: { __typename?: 'Organization', id: string, name: string, slug: string, orgType?: OrgType | null | undefined, logoUrl?: string | null | undefined } }> } | null | undefined };

export type MyNotificationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyNotificationsQuery = { __typename?: 'Query', myNotifications: Array<{ __typename?: 'Notification', id: string, type: string, title: string, body: string, readAt?: string | null | undefined, data?: any | null | undefined, createdAt: string }> };

export type UnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadCountQuery = { __typename?: 'Query', unreadCount: number };

export type MarkNotificationReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkNotificationReadMutation = { __typename?: 'Mutation', markNotificationRead: { __typename?: 'Notification', id: string, readAt?: string | null | undefined } };

export type MarkAllReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllReadMutation = { __typename?: 'Mutation', markAllRead: number };

export type SendTestNotificationMutationVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendTestNotificationMutation = { __typename?: 'Mutation', sendTestNotification: { __typename?: 'Notification', id: string, type: string, title: string, body: string, readAt?: string | null | undefined, createdAt: string } };

export type NotificationReceivedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationReceivedSubscription = { __typename?: 'Subscription', notificationReceived: { __typename?: 'Notification', id: string, type: string, title: string, body: string, readAt?: string | null | undefined, createdAt: string } };

export type CoursesListQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type CoursesListQuery = { __typename?: 'Query', courses: Array<{ __typename?: 'Course', id: string, name: string, description?: string | null | undefined, createdAt: string, enrolments: Array<{ __typename?: 'Enrolment', id: string, status: EnrolmentStatus, enrolledAt: string, completedAt?: string | null | undefined, user: { __typename?: 'User', id: string, displayName: string, email: string } }> }> };

export type CreateCourseMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  input: CreateCourseInput;
}>;


export type CreateCourseMutation = { __typename?: 'Mutation', createCourse: { __typename?: 'Course', id: string, name: string, description?: string | null | undefined } };

export type UpdateCourseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCourseInput;
}>;


export type UpdateCourseMutation = { __typename?: 'Mutation', updateCourse: { __typename?: 'Course', id: string, name: string, description?: string | null | undefined } };

export type DeleteCourseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCourseMutation = { __typename?: 'Mutation', deleteCourse: boolean };

export type EnrolUserMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type EnrolUserMutation = { __typename?: 'Mutation', enrolUser: { __typename?: 'Enrolment', id: string, status: EnrolmentStatus, enrolledAt: string, user: { __typename?: 'User', id: string, displayName: string } } };

export type OrgSettingsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type OrgSettingsQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organization', id: string, name: string, slug: string, orgType?: OrgType | null | undefined, homePort?: string | null | undefined, logoUrl?: string | null | undefined, createdAt: string, preferences: { __typename?: 'OrgPreferences', autoIssueCerts: boolean, requireInstructorApproval: boolean, publicCrewProfiles: boolean, surveyReminders: boolean }, members: Array<{ __typename?: 'OrganizationMembership', id: string, roles: Array<OrgRole>, user: { __typename?: 'User', id: string, displayName: string, email: string, firstName: string, lastName: string } }>, invitations: Array<{ __typename?: 'Invitation', id: string, email: string, roles: Array<OrgRole>, status: InvitationStatus, expiresAt: string }> } | null | undefined };

export type UpdateOrganisationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateOrganisationInput;
}>;


export type UpdateOrganisationMutation = { __typename?: 'Mutation', updateOrganisation: { __typename?: 'Organization', id: string, name: string, slug: string, orgType?: OrgType | null | undefined, homePort?: string | null | undefined, logoUrl?: string | null | undefined } };

export type GenerateOrgLogoUploadUrlMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type GenerateOrgLogoUploadUrlMutation = { __typename?: 'Mutation', generateOrgLogoUploadUrl: { __typename?: 'UploadUrl', uploadUrl: string, key: string } };

export type UpdateOrgPreferencesMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  input: UpdateOrgPreferencesInput;
}>;


export type UpdateOrgPreferencesMutation = { __typename?: 'Mutation', updateOrgPreferences: { __typename?: 'OrgPreferences', autoIssueCerts: boolean, requireInstructorApproval: boolean, publicCrewProfiles: boolean, surveyReminders: boolean } };

export type SkillCategoriesListQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type SkillCategoriesListQuery = { __typename?: 'Query', skillCategories: Array<{ __typename?: 'SkillCategory', id: string, name: string, description?: string | null | undefined, sortOrder: number, skills: Array<{ __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, ratingSystem: RatingSystem, level?: SkillLevelTier | null | undefined, levels: Array<{ __typename?: 'SkillLevel', id: string, label: string, numericValue?: number | null | undefined, sortOrder: number }> }> }> };

export type CreateSkillCategoryMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  input: CreateSkillCategoryInput;
}>;


export type CreateSkillCategoryMutation = { __typename?: 'Mutation', createSkillCategory: { __typename?: 'SkillCategory', id: string, name: string, description?: string | null | undefined, sortOrder: number } };

export type UpdateSkillCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSkillCategoryInput;
}>;


export type UpdateSkillCategoryMutation = { __typename?: 'Mutation', updateSkillCategory: { __typename?: 'SkillCategory', id: string, name: string, description?: string | null | undefined, sortOrder: number } };

export type DeleteSkillCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSkillCategoryMutation = { __typename?: 'Mutation', deleteSkillCategory: boolean };

export type CreateSkillMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
  input: CreateSkillInput;
}>;


export type CreateSkillMutation = { __typename?: 'Mutation', createSkill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, ratingSystem: RatingSystem, level?: SkillLevelTier | null | undefined, levels: Array<{ __typename?: 'SkillLevel', id: string, label: string, numericValue?: number | null | undefined, sortOrder: number }> } };

export type UpdateSkillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSkillInput;
}>;


export type UpdateSkillMutation = { __typename?: 'Mutation', updateSkill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, ratingSystem: RatingSystem, level?: SkillLevelTier | null | undefined, levels: Array<{ __typename?: 'SkillLevel', id: string, label: string, numericValue?: number | null | undefined, sortOrder: number }> } };

export type DeleteSkillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSkillMutation = { __typename?: 'Mutation', deleteSkill: boolean };

export type AddSkillLevelMutationVariables = Exact<{
  skillId: Scalars['ID']['input'];
  input: SkillLevelInput;
}>;


export type AddSkillLevelMutation = { __typename?: 'Mutation', addSkillLevel: { __typename?: 'SkillLevel', id: string, label: string, numericValue?: number | null | undefined, sortOrder: number } };

export type RemoveSkillLevelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveSkillLevelMutation = { __typename?: 'Mutation', removeSkillLevel: boolean };

export type SkillAssessmentsForUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
}>;


export type SkillAssessmentsForUserQuery = { __typename?: 'Query', skillAssessments: Array<{ __typename?: 'SkillAssessment', id: string, ratingValue: string, numericValue?: number | null | undefined, passed: boolean, notes?: string | null | undefined, assessedAt: string, skill: { __typename?: 'Skill', id: string }, crewMembership?: { __typename?: 'CrewMembership', id: string, expedition: { __typename?: 'Expedition', id: string, name: string } } | null | undefined }> };

export type RecordSkillAssessmentMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  input: RecordSkillAssessmentInput;
}>;


export type RecordSkillAssessmentMutation = { __typename?: 'Mutation', recordSkillAssessment: { __typename?: 'SkillAssessment', id: string, ratingValue: string, numericValue?: number | null | undefined, passed: boolean, notes?: string | null | undefined, assessedAt: string } };

export type SkillTemplatesListQueryVariables = Exact<{ [key: string]: never; }>;


export type SkillTemplatesListQuery = { __typename?: 'Query', skillTemplates: Array<{ __typename?: 'SkillTemplate', id: string, key: string, name: string, description?: string | null | undefined, framework?: string | null | undefined, dominantLevel?: SkillLevelTier | null | undefined, skillCount: number, categories: Array<{ __typename?: 'SkillTemplateCategoryPreview', name: string, skillCount: number, skills: Array<{ __typename?: 'SkillTemplateSkillPreview', name: string, ratingSystem: RatingSystem }> }> }> };

export type ImportSkillTemplateMutationVariables = Exact<{
  templateKey: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
}>;


export type ImportSkillTemplateMutation = { __typename?: 'Mutation', importSkillTemplate: { __typename?: 'ImportSkillTemplateResult', categoriesCreated: number, skillsCreated: number } };

export type VesselPingsSubscriptionVariables = Exact<{
  expeditionId: Scalars['ID']['input'];
}>;


export type VesselPingsSubscription = { __typename?: 'Subscription', vesselPings: { __typename?: 'VesselPing', expeditionId: string, vesselId: string, lat: number, lng: number, speedKnots?: number | null | undefined, heading?: number | null | undefined, altitudeM?: number | null | undefined, time: string } };

export type RecordVesselPingMutationVariables = Exact<{
  input: RecordVesselPingInput;
}>;


export type RecordVesselPingMutation = { __typename?: 'Mutation', recordVesselPing: { __typename?: 'VesselPing', expeditionId: string, vesselId: string, lat: number, lng: number, speedKnots?: number | null | undefined, heading?: number | null | undefined, altitudeM?: number | null | undefined, time: string } };

export type VesselPhotoFieldsFragment = { __typename?: 'VesselPhoto', id: string, vesselId: string, url: string, r2Key: string, caption?: string | null | undefined, isCover: boolean, sortOrder: number, sizeBytes?: number | null | undefined, createdAt: string };

export type VesselsListQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type VesselsListQuery = { __typename?: 'Query', vessels: Array<{ __typename?: 'Vessel', id: string, slug: string, name: string, make?: string | null | undefined, model?: string | null | undefined, yearBuilt?: number | null | undefined, vesselType?: VesselType | null | undefined, status: VesselStatus, source: VesselSource, registration?: string | null | undefined, mmsiNumber?: string | null | undefined, callSign?: string | null | undefined, homePort?: string | null | undefined, flagState?: string | null | undefined, lengthM?: number | null | undefined, beamM?: number | null | undefined, draftM?: number | null | undefined, berths?: number | null | undefined, maxPassengers?: number | null | undefined, enginePowerKw?: number | null | undefined, fuelCapacityL?: number | null | undefined, waterCapacityL?: number | null | undefined, charterCompanyName?: string | null | undefined, charterCompanyContact?: string | null | undefined, charterStartDate?: string | null | undefined, charterEndDate?: string | null | undefined, coverPhotoUrl?: string | null | undefined, createdAt: string, expeditionAssignments: Array<{ __typename?: 'ExpeditionVessel', id: string, expedition: { __typename?: 'Expedition', id: string, name: string, status: ExpeditionStatus } }> }> };

export type VesselBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type VesselBySlugQuery = { __typename?: 'Query', vesselBySlug?: { __typename?: 'Vessel', id: string, slug: string, name: string, make?: string | null | undefined, model?: string | null | undefined, yearBuilt?: number | null | undefined, vesselType?: VesselType | null | undefined, status: VesselStatus, source: VesselSource, registration?: string | null | undefined, mmsiNumber?: string | null | undefined, callSign?: string | null | undefined, homePort?: string | null | undefined, flagState?: string | null | undefined, lengthM?: number | null | undefined, beamM?: number | null | undefined, draftM?: number | null | undefined, berths?: number | null | undefined, maxPassengers?: number | null | undefined, enginePowerKw?: number | null | undefined, fuelCapacityL?: number | null | undefined, waterCapacityL?: number | null | undefined, charterCompanyName?: string | null | undefined, charterCompanyContact?: string | null | undefined, charterStartDate?: string | null | undefined, charterEndDate?: string | null | undefined, coverPhotoUrl?: string | null | undefined, createdAt: string, updatedAt: string, photos: Array<{ __typename?: 'VesselPhoto', id: string, vesselId: string, url: string, r2Key: string, caption?: string | null | undefined, isCover: boolean, sortOrder: number, sizeBytes?: number | null | undefined, createdAt: string }>, expeditionAssignments: Array<{ __typename?: 'ExpeditionVessel', id: string, role?: VesselRole | null | undefined, expedition: { __typename?: 'Expedition', id: string, name: string, slug: string, status: ExpeditionStatus, departureDate?: string | null | undefined, maxCrew: number, crew: Array<{ __typename?: 'CrewMembership', id: string }> } }> } | null | undefined };

export type VesselDocumentsQueryVariables = Exact<{
  vesselId: Scalars['ID']['input'];
}>;


export type VesselDocumentsQuery = { __typename?: 'Query', vesselDocuments: Array<{ __typename?: 'VesselDocument', id: string, vesselId: string, docType: VesselDocType, title: string, url: string, r2Key: string, issuedAt?: string | null | undefined, expiresAt?: string | null | undefined, notes?: string | null | undefined, createdAt: string, updatedAt: string }> };

export type VesselMaintenanceLogsQueryVariables = Exact<{
  vesselId: Scalars['ID']['input'];
}>;


export type VesselMaintenanceLogsQuery = { __typename?: 'Query', vesselMaintenanceLogs: Array<{ __typename?: 'VesselMaintenanceLog', id: string, vesselId: string, performedAt: string, engineHoursAtService?: number | null | undefined, workPerformed: string, partsReplaced?: string | null | undefined, performedBy?: string | null | undefined, nextServiceDue?: string | null | undefined, nextServiceEngineHours?: number | null | undefined, notes?: string | null | undefined, createdAt: string, updatedAt: string }> };

export type GenerateVesselDocumentUploadUrlMutationVariables = Exact<{
  vesselId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type GenerateVesselDocumentUploadUrlMutation = { __typename?: 'Mutation', generateVesselDocumentUploadUrl: { __typename?: 'UploadUrl', uploadUrl: string, key: string } };

export type CreateVesselDocumentMutationVariables = Exact<{
  vesselId: Scalars['ID']['input'];
  input: CreateVesselDocumentInput;
}>;


export type CreateVesselDocumentMutation = { __typename?: 'Mutation', createVesselDocument: { __typename?: 'VesselDocument', id: string, vesselId: string, docType: VesselDocType, title: string, url: string, r2Key: string, issuedAt?: string | null | undefined, expiresAt?: string | null | undefined, notes?: string | null | undefined, createdAt: string } };

export type DeleteVesselDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteVesselDocumentMutation = { __typename?: 'Mutation', deleteVesselDocument: boolean };

export type CreateVesselMaintenanceLogMutationVariables = Exact<{
  vesselId: Scalars['ID']['input'];
  input: CreateVesselMaintenanceLogInput;
}>;


export type CreateVesselMaintenanceLogMutation = { __typename?: 'Mutation', createVesselMaintenanceLog: { __typename?: 'VesselMaintenanceLog', id: string, vesselId: string, performedAt: string, engineHoursAtService?: number | null | undefined, workPerformed: string, partsReplaced?: string | null | undefined, performedBy?: string | null | undefined, nextServiceDue?: string | null | undefined, nextServiceEngineHours?: number | null | undefined, notes?: string | null | undefined, createdAt: string } };

export type VesselFieldsFragment = { __typename?: 'Vessel', id: string, slug: string, name: string, make?: string | null | undefined, model?: string | null | undefined, yearBuilt?: number | null | undefined, vesselType?: VesselType | null | undefined, status: VesselStatus, source: VesselSource, registration?: string | null | undefined, mmsiNumber?: string | null | undefined, callSign?: string | null | undefined, homePort?: string | null | undefined, flagState?: string | null | undefined, lengthM?: number | null | undefined, beamM?: number | null | undefined, draftM?: number | null | undefined, berths?: number | null | undefined, maxPassengers?: number | null | undefined, enginePowerKw?: number | null | undefined, fuelCapacityL?: number | null | undefined, waterCapacityL?: number | null | undefined, charterCompanyName?: string | null | undefined, charterCompanyContact?: string | null | undefined, charterStartDate?: string | null | undefined, charterEndDate?: string | null | undefined, coverPhotoUrl?: string | null | undefined };

export type CreateVesselMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  input: CreateVesselInput;
}>;


export type CreateVesselMutation = { __typename?: 'Mutation', createVessel: { __typename?: 'Vessel', id: string, slug: string, name: string, make?: string | null | undefined, model?: string | null | undefined, yearBuilt?: number | null | undefined, vesselType?: VesselType | null | undefined, status: VesselStatus, source: VesselSource, registration?: string | null | undefined, mmsiNumber?: string | null | undefined, callSign?: string | null | undefined, homePort?: string | null | undefined, flagState?: string | null | undefined, lengthM?: number | null | undefined, beamM?: number | null | undefined, draftM?: number | null | undefined, berths?: number | null | undefined, maxPassengers?: number | null | undefined, enginePowerKw?: number | null | undefined, fuelCapacityL?: number | null | undefined, waterCapacityL?: number | null | undefined, charterCompanyName?: string | null | undefined, charterCompanyContact?: string | null | undefined, charterStartDate?: string | null | undefined, charterEndDate?: string | null | undefined, coverPhotoUrl?: string | null | undefined } };

export type UpdateVesselMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateVesselInput;
}>;


export type UpdateVesselMutation = { __typename?: 'Mutation', updateVessel: { __typename?: 'Vessel', id: string, slug: string, name: string, make?: string | null | undefined, model?: string | null | undefined, yearBuilt?: number | null | undefined, vesselType?: VesselType | null | undefined, status: VesselStatus, source: VesselSource, registration?: string | null | undefined, mmsiNumber?: string | null | undefined, callSign?: string | null | undefined, homePort?: string | null | undefined, flagState?: string | null | undefined, lengthM?: number | null | undefined, beamM?: number | null | undefined, draftM?: number | null | undefined, berths?: number | null | undefined, maxPassengers?: number | null | undefined, enginePowerKw?: number | null | undefined, fuelCapacityL?: number | null | undefined, waterCapacityL?: number | null | undefined, charterCompanyName?: string | null | undefined, charterCompanyContact?: string | null | undefined, charterStartDate?: string | null | undefined, charterEndDate?: string | null | undefined, coverPhotoUrl?: string | null | undefined } };

export type UpdateVesselStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: VesselStatus;
}>;


export type UpdateVesselStatusMutation = { __typename?: 'Mutation', updateVesselStatus: { __typename?: 'Vessel', id: string, status: VesselStatus } };

export type DeleteVesselMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteVesselMutation = { __typename?: 'Mutation', deleteVessel: boolean };

export type GenerateVesselUploadUrlMutationVariables = Exact<{
  vesselId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type GenerateVesselUploadUrlMutation = { __typename?: 'Mutation', generateVesselUploadUrl: { __typename?: 'UploadUrl', uploadUrl: string, key: string } };

export type AddVesselPhotoMutationVariables = Exact<{
  vesselId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  caption?: InputMaybe<Scalars['String']['input']>;
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddVesselPhotoMutation = { __typename?: 'Mutation', addVesselPhoto: { __typename?: 'VesselPhoto', id: string, vesselId: string, url: string, r2Key: string, caption?: string | null | undefined, isCover: boolean, sortOrder: number, sizeBytes?: number | null | undefined, createdAt: string } };

export type SetVesselCoverPhotoMutationVariables = Exact<{
  photoId: Scalars['ID']['input'];
}>;


export type SetVesselCoverPhotoMutation = { __typename?: 'Mutation', setVesselCoverPhoto: { __typename?: 'Vessel', id: string, coverPhotoUrl?: string | null | undefined, photos: Array<{ __typename?: 'VesselPhoto', id: string, vesselId: string, url: string, r2Key: string, caption?: string | null | undefined, isCover: boolean, sortOrder: number, sizeBytes?: number | null | undefined, createdAt: string }> } };

export type DeleteVesselPhotoMutationVariables = Exact<{
  photoId: Scalars['ID']['input'];
}>;


export type DeleteVesselPhotoMutation = { __typename?: 'Mutation', deleteVesselPhoto: boolean };

export const CertFieldsFragmentDoc = gql`
    fragment CertFields on Certificate {
  id
  title
  description
  issuedAt
  revokedAt
  verificationCode
  pdfUrl
  issuedTo {
    id
    displayName
    email
  }
  issuedBy {
    id
    displayName
  }
  expedition {
    id
    name
  }
  course {
    id
    name
  }
}
    `;
export const ProfileUserDocumentFieldsFragmentDoc = gql`
    fragment ProfileUserDocumentFields on UserDocument {
  id
  documentType
  title
  issuingBody
  issuingCountry
  referenceNumber
  issuedAt
  expiresAt
  documentUrl
  visibility
  isVerified
  verifiedAt
}
    `;
export const ProfileSkillAssessmentFieldsFragmentDoc = gql`
    fragment ProfileSkillAssessmentFields on SkillAssessment {
  id
  skill {
    id
    name
    description
    ratingSystem
    category {
      id
      name
    }
  }
  assessor {
    id
    displayName
    avatarUrl
  }
  crewMembership {
    id
    expedition {
      id
      slug
      name
    }
  }
  ratingValue
  numericValue
  passed
  notes
  assessedAt
}
    `;
export const ProfileCrewMembershipFieldsFragmentDoc = gql`
    fragment ProfileCrewMembershipFields on CrewMembership {
  id
  role
  joinType
  status
  joinedAt
  expedition {
    id
    slug
    name
    status
    departureDate
    returnDate
  }
}
    `;
export const UserDocumentFieldsFragmentDoc = gql`
    fragment UserDocumentFields on UserDocument {
  id
  userId
  documentType
  title
  issuingBody
  issuingCountry
  referenceNumber
  issuedAt
  expiresAt
  documentUrl
  levelNotes
  visibility
  isVerified
  verifiedAt
  createdAt
  updatedAt
}
    `;
export const VesselDocumentFieldsFragmentDoc = gql`
    fragment VesselDocumentFields on VesselDocument {
  id
  vesselId
  docType
  title
  url
  issuedAt
  expiresAt
  notes
  createdAt
}
    `;
export const VesselPhotoFieldsFragmentDoc = gql`
    fragment VesselPhotoFields on VesselPhoto {
  id
  vesselId
  url
  r2Key
  caption
  isCover
  sortOrder
  sizeBytes
  createdAt
}
    `;
export const VesselFieldsFragmentDoc = gql`
    fragment VesselFields on Vessel {
  id
  slug
  name
  make
  model
  yearBuilt
  vesselType
  status
  source
  registration
  mmsiNumber
  callSign
  homePort
  flagState
  lengthM
  beamM
  draftM
  berths
  maxPassengers
  enginePowerKw
  fuelCapacityL
  waterCapacityL
  charterCompanyName
  charterCompanyContact
  charterStartDate
  charterEndDate
  coverPhotoUrl
}
    `;
export const CertificatesListDocument = gql`
    query CertificatesList($orgId: ID!) {
  certificates(orgId: $orgId) {
    ...CertFields
  }
}
    ${CertFieldsFragmentDoc}`;
export const MyCertificatesDocument = gql`
    query MyCertificates {
  myCertificates {
    ...CertFields
  }
}
    ${CertFieldsFragmentDoc}`;
export const CertificateByCodeDocument = gql`
    query CertificateByCode($verificationCode: String!) {
  certificate(verificationCode: $verificationCode) {
    id
    pdfUrl
  }
}
    `;
export const IssueCertificateDocument = gql`
    mutation IssueCertificate($input: IssueCertificateInput!) {
  issueCertificate(input: $input) {
    ...CertFields
  }
}
    ${CertFieldsFragmentDoc}`;
export const RevokeCertificateDocument = gql`
    mutation RevokeCertificate($id: ID!) {
  revokeCertificate(id: $id) {
    id
    revokedAt
  }
}
    `;
export const RegenerateCertificatePdfDocument = gql`
    mutation RegenerateCertificatePdf($id: ID!) {
  regenerateCertificatePdf(id: $id) {
    id
    pdfUrl
  }
}
    `;
export const CertPdfReadyDocument = gql`
    subscription CertPdfReady($certId: ID!) {
  certPdfReady(certId: $certId) {
    id
    pdfUrl
  }
}
    `;
export const CharterListingsListDocument = gql`
    query CharterListingsList($orgId: ID!) {
  charterListings(orgId: $orgId) {
    id
    title
    description
    status
    pricePerDayUsd
    maxGuests
    availableFrom
    availableTo
    createdAt
    vessel {
      id
      name
      vesselType
    }
  }
}
    `;
export const CharterBookingsListDocument = gql`
    query CharterBookingsList($orgId: ID!) {
  charterBookings(orgId: $orgId) {
    id
    status
    startDate
    endDate
    totalPriceUsd
    createdAt
    listing {
      id
      title
      vessel {
        id
        name
      }
    }
    guest {
      id
      displayName
      email
    }
  }
}
    `;
export const CreateCharterListingDocument = gql`
    mutation CreateCharterListing($orgId: ID!, $vesselId: ID!, $input: CreateCharterListingInput!) {
  createCharterListing(orgId: $orgId, vesselId: $vesselId, input: $input) {
    id
    title
    status
    pricePerDayUsd
    availableFrom
    availableTo
  }
}
    `;
export const UpdateCharterListingDocument = gql`
    mutation UpdateCharterListing($id: ID!, $input: UpdateCharterListingInput!) {
  updateCharterListing(id: $id, input: $input) {
    id
    title
    status
    pricePerDayUsd
  }
}
    `;
export const DeleteCharterListingDocument = gql`
    mutation DeleteCharterListing($id: ID!) {
  deleteCharterListing(id: $id) {
    id
  }
}
    `;
export const ConfirmBookingDocument = gql`
    mutation ConfirmBooking($id: ID!) {
  confirmBooking(id: $id) {
    id
    status
  }
}
    `;
export const CancelBookingDocument = gql`
    mutation CancelBooking($id: ID!) {
  cancelBooking(id: $id) {
    id
    status
  }
}
    `;
export const CrewProfileDocument = gql`
    query CrewProfile($userId: ID!) {
  user(id: $userId) {
    id
    displayName
    firstName
    lastName
    email
    avatarUrl
    bio
    homePort
    totalMilesLogged
    memberships {
      id
      roles
      createdAt
      organisation {
        id
        name
      }
    }
    sailingMiles {
      totalMiles
      expeditionCount
    }
    crewMemberships {
      ...ProfileCrewMembershipFields
    }
    skillAssessments {
      ...ProfileSkillAssessmentFields
    }
  }
}
    ${ProfileCrewMembershipFieldsFragmentDoc}
${ProfileSkillAssessmentFieldsFragmentDoc}`;
export const CrewProfileDocumentsDocument = gql`
    query CrewProfileDocuments($userId: ID!) {
  userDocuments(userId: $userId) {
    ...ProfileUserDocumentFields
  }
}
    ${ProfileUserDocumentFieldsFragmentDoc}`;
export const CrewProfileCertificatesDocument = gql`
    query CrewProfileCertificates($orgId: ID!) {
  certificates(orgId: $orgId) {
    id
    title
    description
    issuedAt
    revokedAt
    verificationCode
    pdfUrl
    issuedTo {
      id
    }
    expedition {
      id
      name
    }
    course {
      id
      name
    }
  }
}
    `;
export const CrewProfileMilesAwardsDocument = gql`
    query CrewProfileMilesAwards($userId: ID!) {
  userMilesAwards(userId: $userId) {
    id
    userId
    expeditionId
    miles
    crewRole
    awardedAt
  }
}
    `;
export const OrgCrewListDocument = gql`
    query OrgCrewList($orgId: ID!) {
  organisation(id: $orgId) {
    id
    members {
      id
      roles
      createdAt
      user {
        id
        displayName
        firstName
        lastName
        avatarUrl
        totalMilesLogged
        crewMemberships {
          id
          status
          expedition {
            id
            name
            status
          }
        }
      }
    }
  }
}
    `;
export const OrgMembersDocument = gql`
    query OrgMembers($orgId: ID!) {
  organisation(id: $orgId) {
    id
    name
    members {
      id
      roles
      createdAt
      user {
        id
        firstName
        lastName
        email
        displayName
        avatarUrl
      }
    }
    invitations {
      id
      email
      roles
      status
      expiresAt
    }
  }
}
    `;
export const InviteMemberDocument = gql`
    mutation InviteMember($orgId: ID!, $input: InviteMemberInput!) {
  inviteMember(orgId: $orgId, input: $input) {
    id
    email
    roles
    status
    expiresAt
  }
}
    `;
export const UpdateMemberRolesDocument = gql`
    mutation UpdateMemberRoles($orgId: ID!, $userId: ID!, $roles: [OrgRole!]!) {
  updateMemberRoles(orgId: $orgId, userId: $userId, roles: $roles) {
    id
    roles
    user {
      id
      displayName
    }
  }
}
    `;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($orgId: ID!, $userId: ID!) {
  removeMember(orgId: $orgId, userId: $userId)
}
    `;
export const DashboardExpeditionsDocument = gql`
    query DashboardExpeditions($orgId: ID!) {
  activeExpeditions: expeditions(orgId: $orgId, status: ACTIVE) {
    id
    slug
    name
    status
    departureDate
    returnDate
    maxCrew
    route {
      id
      name
      totalDistanceNm
    }
    vessels {
      id
      vessel {
        id
        name
      }
    }
    crew {
      id
      role
      status
      user {
        id
        firstName
        lastName
        displayName
        avatarUrl
      }
    }
  }
  openExpeditions: expeditions(orgId: $orgId, status: OPEN) {
    id
    slug
    name
    departureDate
    returnDate
    maxCrew
    route {
      id
      name
      totalDistanceNm
    }
    crew {
      id
      status
    }
  }
}
    `;
export const DashboardOrgDocument = gql`
    query DashboardOrg($orgId: ID!) {
  organisation(id: $orgId) {
    id
    name
    members {
      id
      roles
      user {
        id
        displayName
        avatarUrl
      }
    }
    invitations {
      id
      email
      status
    }
  }
  vessels(orgId: $orgId) {
    id
    slug
    name
    status
    homePort
    expeditionAssignments {
      id
      expedition {
        id
        name
        status
      }
    }
  }
}
    `;
export const DashboardMeDocument = gql`
    query DashboardMe {
  me {
    id
    firstName
    lastName
    displayName
    avatarUrl
    totalMilesLogged
    sailingMiles {
      totalMiles
      expeditionCount
    }
  }
  myCertificates {
    id
  }
}
    `;
export const MyDocumentsDocument = gql`
    query MyDocuments {
  myDocuments {
    ...UserDocumentFields
  }
}
    ${UserDocumentFieldsFragmentDoc}`;
export const UserDocumentsDocument = gql`
    query UserDocuments($userId: ID!) {
  userDocuments(userId: $userId) {
    ...UserDocumentFields
  }
}
    ${UserDocumentFieldsFragmentDoc}`;
export const AddUserDocumentDocument = gql`
    mutation AddUserDocument($input: AddUserDocumentInput!) {
  addUserDocument(input: $input) {
    ...UserDocumentFields
  }
}
    ${UserDocumentFieldsFragmentDoc}`;
export const PresignUserDocumentUploadDocument = gql`
    mutation PresignUserDocumentUpload($documentId: ID!, $fileName: String!, $contentType: String!) {
  presignUserDocumentUpload(
    documentId: $documentId
    fileName: $fileName
    contentType: $contentType
  ) {
    uploadUrl
    r2Key
  }
}
    `;
export const ConfirmUserDocumentUploadDocument = gql`
    mutation ConfirmUserDocumentUpload($documentId: ID!, $r2Key: String!, $documentUrl: String!) {
  confirmUserDocumentUpload(
    documentId: $documentId
    r2Key: $r2Key
    documentUrl: $documentUrl
  ) {
    ...UserDocumentFields
  }
}
    ${UserDocumentFieldsFragmentDoc}`;
export const DeleteUserDocumentDocument = gql`
    mutation DeleteUserDocument($id: ID!) {
  deleteUserDocument(id: $id)
}
    `;
export const RoutesListDocument = gql`
    query RoutesList($orgId: ID!) {
  routes(orgId: $orgId) {
    id
    name
    description
    totalDistanceNm
    createdAt
    updatedAt
    waypoints {
      id
      name
      lat
      lng
      orderIndex
    }
  }
}
    `;
export const RouteDetailDocument = gql`
    query RouteDetail($id: ID!) {
  route(id: $id) {
    id
    name
    description
    totalDistanceNm
    createdAt
    updatedAt
    waypoints {
      id
      name
      lat
      lng
      orderIndex
    }
  }
}
    `;
export const CreateRouteDocument = gql`
    mutation CreateRoute($orgId: ID!, $input: CreateRouteInput!) {
  createRoute(orgId: $orgId, input: $input) {
    id
    name
    description
    totalDistanceNm
    waypoints {
      id
      name
      lat
      lng
      orderIndex
    }
  }
}
    `;
export const UpdateRouteDocument = gql`
    mutation UpdateRoute($id: ID!, $input: UpdateRouteInput!) {
  updateRoute(id: $id, input: $input) {
    id
    name
    description
  }
}
    `;
export const DeleteRouteDocument = gql`
    mutation DeleteRoute($id: ID!) {
  deleteRoute(id: $id)
}
    `;
export const AddWaypointDocument = gql`
    mutation AddWaypoint($routeId: ID!, $input: WaypointInput!) {
  addWaypoint(routeId: $routeId, input: $input) {
    id
    name
    lat
    lng
    orderIndex
  }
}
    `;
export const ReorderWaypointsDocument = gql`
    mutation ReorderWaypoints($routeId: ID!, $waypointIds: [ID!]!) {
  reorderWaypoints(routeId: $routeId, waypointIds: $waypointIds) {
    id
    orderIndex
  }
}
    `;
export const AssignVesselDocument = gql`
    mutation AssignVessel($expeditionId: ID!, $vesselId: ID!, $role: VesselRole) {
  assignVessel(expeditionId: $expeditionId, vesselId: $vesselId, role: $role) {
    id
    role
    vessel {
      id
      name
    }
  }
}
    `;
export const RemoveVesselDocument = gql`
    mutation RemoveVessel($expeditionVesselId: ID!) {
  removeVessel(expeditionVesselId: $expeditionVesselId)
}
    `;
export const SetCrewVesselDocument = gql`
    mutation SetCrewVessel($membershipId: ID!, $vesselId: ID) {
  setCrewVessel(membershipId: $membershipId, vesselId: $vesselId) {
    id
    vesselId
  }
}
    `;
export const ExpeditionsListDocument = gql`
    query ExpeditionsList($orgId: ID!, $status: ExpeditionStatus) {
  expeditions(orgId: $orgId, status: $status) {
    id
    slug
    name
    status
    kind
    departureDate
    returnDate
    maxCrew
    route {
      id
      name
      totalDistanceNm
    }
    vessels {
      id
      vessel {
        id
        name
      }
    }
    crew {
      id
      role
      status
      joinType
      user {
        id
        displayName
        firstName
        lastName
      }
    }
  }
}
    `;
export const ExpeditionDetailDocument = gql`
    query ExpeditionDetail($id: ID!) {
  expedition(id: $id) {
    id
    slug
    name
    status
    departureDate
    returnDate
    maxCrew
    route {
      id
      name
      description
      totalDistanceNm
      waypoints {
        id
        name
        lat
        lng
        orderIndex
      }
    }
    vessels {
      id
      assignedAt
      vessel {
        id
        name
      }
    }
    crew {
      id
      role
      joinType
      joinedAt
      user {
        id
      }
    }
  }
}
    `;
export const CreateExpeditionDocument = gql`
    mutation CreateExpedition($orgId: ID!, $input: CreateExpeditionInput!) {
  createExpedition(orgId: $orgId, input: $input) {
    id
    slug
    name
    status
    departureDate
    returnDate
    maxCrew
  }
}
    `;
export const UpdateExpeditionStatusDocument = gql`
    mutation UpdateExpeditionStatus($id: ID!, $status: ExpeditionStatus!) {
  updateExpeditionStatus(id: $id, status: $status) {
    id
    status
  }
}
    `;
export const ExpeditionBySlugDocument = gql`
    query ExpeditionBySlug($slug: String!) {
  expeditionBySlug(slug: $slug) {
    id
    slug
    name
    status
    kind
    departureDate
    returnDate
    maxCrew
    route {
      id
      name
      description
      totalDistanceNm
      waypoints {
        id
        name
        lat
        lng
        orderIndex
        estimatedLegHours
        plannedArrival
      }
    }
    vessels {
      id
      role
      assignedAt
      vessel {
        id
        name
        vesselType
        homePort
      }
    }
    crew {
      id
      role
      vesselId
      joinType
      status
      joinedAt
      user {
        id
        displayName
        firstName
        lastName
        email
        avatarUrl
        totalMilesLogged
      }
    }
  }
}
    `;
export const ExpeditionExpensesDocument = gql`
    query ExpeditionExpenses($expeditionId: ID!) {
  expenseSummary(expeditionId: $expeditionId) {
    expeditionId
    totalAmountCents
    perPerson {
      userId
      totalOwedCents
      totalOwesToCents
      netCents
    }
  }
}
    `;
export const ExpeditionExpensesListDocument = gql`
    query ExpeditionExpensesList($expeditionId: ID!) {
  expenses(expeditionId: $expeditionId) {
    id
    description
    amountCents
    currency
    receiptUrl
    createdAt
    recordedBy {
      id
      displayName
      firstName
      lastName
      avatarUrl
    }
    splits {
      id
      amountCents
      settledAt
      owedBy {
        id
        displayName
        firstName
        lastName
      }
      owedTo {
        id
        displayName
        firstName
        lastName
      }
    }
  }
}
    `;
export const RecordExpenseDocument = gql`
    mutation RecordExpense($expeditionId: ID!, $input: RecordExpenseInput!) {
  recordExpense(expeditionId: $expeditionId, input: $input) {
    id
    description
    amountCents
    currency
    receiptUrl
    createdAt
    recordedBy {
      id
      displayName
      firstName
      lastName
      avatarUrl
    }
    splits {
      id
      amountCents
      settledAt
      owedBy {
        id
        displayName
        firstName
        lastName
      }
      owedTo {
        id
        displayName
        firstName
        lastName
      }
    }
  }
}
    `;
export const DeleteExpenseDocument = gql`
    mutation DeleteExpense($id: ID!) {
  deleteExpense(id: $id)
}
    `;
export const ApproveCrewMemberDocument = gql`
    mutation ApproveCrewMember($membershipId: ID!) {
  approveCrewMember(membershipId: $membershipId) {
    id
    status
    role
  }
}
    `;
export const DeclineCrewMemberDocument = gql`
    mutation DeclineCrewMember($membershipId: ID!) {
  declineCrewMember(membershipId: $membershipId) {
    id
    status
  }
}
    `;
export const MarkNoShowDocument = gql`
    mutation MarkNoShow($membershipId: ID!) {
  markNoShow(membershipId: $membershipId) {
    id
    status
  }
}
    `;
export const MarkDisembarkedEarlyDocument = gql`
    mutation MarkDisembarkedEarly($membershipId: ID!) {
  markDisembarkedEarly(membershipId: $membershipId) {
    id
    status
  }
}
    `;
export const ReinstateCrewMemberDocument = gql`
    mutation ReinstateCrewMember($membershipId: ID!) {
  reinstateCrewMember(membershipId: $membershipId) {
    id
    status
  }
}
    `;
export const RemoveCrewMemberDocument = gql`
    mutation RemoveCrewMember($membershipId: ID!) {
  removeCrewMember(membershipId: $membershipId)
}
    `;
export const UpdateCrewMembershipRoleDocument = gql`
    mutation UpdateCrewMembershipRole($membershipId: ID!, $role: CrewRole!) {
  updateCrewMembershipRole(membershipId: $membershipId, role: $role) {
    id
    status
    role
  }
}
    `;
export const LogbookEntriesDocument = gql`
    query LogbookEntries($expeditionId: ID!) {
  logbookEntries(expeditionId: $expeditionId) {
    id
    entryTime
    lat
    lng
    windSpeedKnots
    windDirection
    seaState
    barometricPressure
    engineOn
    speedOverGround
    courseOverGround
    notes
    createdAt
    author {
      id
      firstName
      lastName
      displayName
      avatarUrl
    }
  }
}
    `;
export const AddLogbookEntryDocument = gql`
    mutation AddLogbookEntry($expeditionId: ID!, $input: AddLogbookEntryInput!) {
  addLogbookEntry(expeditionId: $expeditionId, input: $input) {
    id
    entryTime
    lat
    lng
    windSpeedKnots
    windDirection
    seaState
    barometricPressure
    engineOn
    speedOverGround
    courseOverGround
    notes
    createdAt
    author {
      id
      firstName
      lastName
      displayName
      avatarUrl
    }
  }
}
    `;
export const DeleteLogbookEntryDocument = gql`
    mutation DeleteLogbookEntry($id: ID!) {
  deleteLogbookEntry(id: $id)
}
    `;
export const JoinExpeditionDocument = gql`
    mutation JoinExpedition($expeditionId: ID!, $input: JoinExpeditionInput!) {
  joinExpedition(expeditionId: $expeditionId, input: $input) {
    id
    status
    role
    joinType
    joinedAt
    user {
      id
    }
  }
}
    `;
export const LeaveExpeditionDocument = gql`
    mutation LeaveExpedition($expeditionId: ID!) {
  leaveExpedition(expeditionId: $expeditionId)
}
    `;
export const InviteCrewDocument = gql`
    mutation InviteCrew($expeditionId: ID!, $input: InviteCrewInput!) {
  inviteCrew(expeditionId: $expeditionId, input: $input) {
    id
    status
    role
    joinType
    joinedAt
    user {
      id
    }
  }
}
    `;
export const SettleExpenseDocument = gql`
    mutation SettleExpense($expeditionId: ID!, $input: SettleExpenseInput!) {
  settleExpense(expeditionId: $expeditionId, input: $input) {
    id
    amountCents
    settledAt
  }
}
    `;
export const RecordSettlementDocument = gql`
    mutation RecordSettlement($expeditionId: ID!, $input: RecordSettlementInput!) {
  recordSettlement(expeditionId: $expeditionId, input: $input) {
    id
    amountCents
    settledAt
  }
}
    `;
export const MeDocument = gql`
    query Me {
  me {
    id
    email
    firstName
    lastName
    memberships {
      id
      roles
      organisation {
        id
        name
        slug
        orgType
        logoUrl
      }
    }
  }
}
    `;
export const MyNotificationsDocument = gql`
    query MyNotifications($limit: Int, $offset: Int) {
  myNotifications(limit: $limit, offset: $offset) {
    id
    type
    title
    body
    readAt
    data
    createdAt
  }
}
    `;
export const UnreadCountDocument = gql`
    query UnreadCount {
  unreadCount
}
    `;
export const MarkNotificationReadDocument = gql`
    mutation MarkNotificationRead($id: ID!) {
  markNotificationRead(id: $id) {
    id
    readAt
  }
}
    `;
export const MarkAllReadDocument = gql`
    mutation MarkAllRead {
  markAllRead
}
    `;
export const SendTestNotificationDocument = gql`
    mutation SendTestNotification($type: String) {
  sendTestNotification(type: $type) {
    id
    type
    title
    body
    readAt
    createdAt
  }
}
    `;
export const NotificationReceivedDocument = gql`
    subscription NotificationReceived {
  notificationReceived {
    id
    type
    title
    body
    readAt
    createdAt
  }
}
    `;
export const CoursesListDocument = gql`
    query CoursesList($orgId: ID!) {
  courses(orgId: $orgId) {
    id
    name
    description
    createdAt
    enrolments {
      id
      status
      enrolledAt
      completedAt
      user {
        id
        displayName
        email
      }
    }
  }
}
    `;
export const CreateCourseDocument = gql`
    mutation CreateCourse($orgId: ID!, $input: CreateCourseInput!) {
  createCourse(orgId: $orgId, input: $input) {
    id
    name
    description
  }
}
    `;
export const UpdateCourseDocument = gql`
    mutation UpdateCourse($id: ID!, $input: UpdateCourseInput!) {
  updateCourse(id: $id, input: $input) {
    id
    name
    description
  }
}
    `;
export const DeleteCourseDocument = gql`
    mutation DeleteCourse($id: ID!) {
  deleteCourse(id: $id)
}
    `;
export const EnrolUserDocument = gql`
    mutation EnrolUser($courseId: ID!, $userId: ID!) {
  enrolUser(courseId: $courseId, userId: $userId) {
    id
    status
    enrolledAt
    user {
      id
      displayName
    }
  }
}
    `;
export const OrgSettingsDocument = gql`
    query OrgSettings($orgId: ID!) {
  organisation(id: $orgId) {
    id
    name
    slug
    orgType
    homePort
    logoUrl
    preferences {
      autoIssueCerts
      requireInstructorApproval
      publicCrewProfiles
      surveyReminders
    }
    createdAt
    members {
      id
      roles
      user {
        id
        displayName
        email
        firstName
        lastName
      }
    }
    invitations {
      id
      email
      roles
      status
      expiresAt
    }
  }
}
    `;
export const UpdateOrganisationDocument = gql`
    mutation UpdateOrganisation($id: ID!, $input: UpdateOrganisationInput!) {
  updateOrganisation(id: $id, input: $input) {
    id
    name
    slug
    orgType
    homePort
    logoUrl
  }
}
    `;
export const GenerateOrgLogoUploadUrlDocument = gql`
    mutation GenerateOrgLogoUploadUrl($orgId: ID!, $filename: String!, $contentType: String!) {
  generateOrgLogoUploadUrl(
    orgId: $orgId
    filename: $filename
    contentType: $contentType
  ) {
    uploadUrl
    key
  }
}
    `;
export const UpdateOrgPreferencesDocument = gql`
    mutation UpdateOrgPreferences($orgId: ID!, $input: UpdateOrgPreferencesInput!) {
  updateOrgPreferences(orgId: $orgId, input: $input) {
    autoIssueCerts
    requireInstructorApproval
    publicCrewProfiles
    surveyReminders
  }
}
    `;
export const SkillCategoriesListDocument = gql`
    query SkillCategoriesList($orgId: ID!) {
  skillCategories(orgId: $orgId) {
    id
    name
    description
    sortOrder
    skills {
      id
      name
      description
      ratingSystem
      level
      levels {
        id
        label
        numericValue
        sortOrder
      }
    }
  }
}
    `;
export const CreateSkillCategoryDocument = gql`
    mutation CreateSkillCategory($orgId: ID!, $input: CreateSkillCategoryInput!) {
  createSkillCategory(orgId: $orgId, input: $input) {
    id
    name
    description
    sortOrder
  }
}
    `;
export const UpdateSkillCategoryDocument = gql`
    mutation UpdateSkillCategory($id: ID!, $input: UpdateSkillCategoryInput!) {
  updateSkillCategory(id: $id, input: $input) {
    id
    name
    description
    sortOrder
  }
}
    `;
export const DeleteSkillCategoryDocument = gql`
    mutation DeleteSkillCategory($id: ID!) {
  deleteSkillCategory(id: $id)
}
    `;
export const CreateSkillDocument = gql`
    mutation CreateSkill($orgId: ID!, $categoryId: ID!, $input: CreateSkillInput!) {
  createSkill(orgId: $orgId, categoryId: $categoryId, input: $input) {
    id
    name
    description
    ratingSystem
    level
    levels {
      id
      label
      numericValue
      sortOrder
    }
  }
}
    `;
export const UpdateSkillDocument = gql`
    mutation UpdateSkill($id: ID!, $input: UpdateSkillInput!) {
  updateSkill(id: $id, input: $input) {
    id
    name
    description
    ratingSystem
    level
    levels {
      id
      label
      numericValue
      sortOrder
    }
  }
}
    `;
export const DeleteSkillDocument = gql`
    mutation DeleteSkill($id: ID!) {
  deleteSkill(id: $id)
}
    `;
export const AddSkillLevelDocument = gql`
    mutation AddSkillLevel($skillId: ID!, $input: SkillLevelInput!) {
  addSkillLevel(skillId: $skillId, input: $input) {
    id
    label
    numericValue
    sortOrder
  }
}
    `;
export const RemoveSkillLevelDocument = gql`
    mutation RemoveSkillLevel($id: ID!) {
  removeSkillLevel(id: $id)
}
    `;
export const SkillAssessmentsForUserDocument = gql`
    query SkillAssessmentsForUser($userId: ID!, $orgId: ID!) {
  skillAssessments(userId: $userId, orgId: $orgId) {
    id
    skill {
      id
    }
    ratingValue
    numericValue
    passed
    notes
    assessedAt
    crewMembership {
      id
      expedition {
        id
        name
      }
    }
  }
}
    `;
export const RecordSkillAssessmentDocument = gql`
    mutation RecordSkillAssessment($orgId: ID!, $input: RecordSkillAssessmentInput!) {
  recordSkillAssessment(orgId: $orgId, input: $input) {
    id
    ratingValue
    numericValue
    passed
    notes
    assessedAt
  }
}
    `;
export const SkillTemplatesListDocument = gql`
    query SkillTemplatesList {
  skillTemplates {
    id
    key
    name
    description
    framework
    dominantLevel
    skillCount
    categories {
      name
      skillCount
      skills {
        name
        ratingSystem
      }
    }
  }
}
    `;
export const ImportSkillTemplateDocument = gql`
    mutation ImportSkillTemplate($templateKey: String!, $orgId: ID!) {
  importSkillTemplate(templateKey: $templateKey, orgId: $orgId) {
    categoriesCreated
    skillsCreated
  }
}
    `;
export const VesselPingsDocument = gql`
    subscription VesselPings($expeditionId: ID!) {
  vesselPings(expeditionId: $expeditionId) {
    expeditionId
    vesselId
    lat
    lng
    speedKnots
    heading
    altitudeM
    time
  }
}
    `;
export const RecordVesselPingDocument = gql`
    mutation RecordVesselPing($input: RecordVesselPingInput!) {
  recordVesselPing(input: $input) {
    expeditionId
    vesselId
    lat
    lng
    speedKnots
    heading
    altitudeM
    time
  }
}
    `;
export const VesselsListDocument = gql`
    query VesselsList($orgId: ID!) {
  vessels(orgId: $orgId) {
    id
    slug
    name
    make
    model
    yearBuilt
    vesselType
    status
    source
    registration
    mmsiNumber
    callSign
    homePort
    flagState
    lengthM
    beamM
    draftM
    berths
    maxPassengers
    enginePowerKw
    fuelCapacityL
    waterCapacityL
    charterCompanyName
    charterCompanyContact
    charterStartDate
    charterEndDate
    coverPhotoUrl
    createdAt
    expeditionAssignments {
      id
      expedition {
        id
        name
        status
      }
    }
  }
}
    `;
export const VesselBySlugDocument = gql`
    query VesselBySlug($slug: String!) {
  vesselBySlug(slug: $slug) {
    id
    slug
    name
    make
    model
    yearBuilt
    vesselType
    status
    source
    registration
    mmsiNumber
    callSign
    homePort
    flagState
    lengthM
    beamM
    draftM
    berths
    maxPassengers
    enginePowerKw
    fuelCapacityL
    waterCapacityL
    charterCompanyName
    charterCompanyContact
    charterStartDate
    charterEndDate
    coverPhotoUrl
    createdAt
    updatedAt
    photos {
      ...VesselPhotoFields
    }
    expeditionAssignments {
      id
      role
      expedition {
        id
        name
        slug
        status
        departureDate
        maxCrew
        crew {
          id
        }
      }
    }
  }
}
    ${VesselPhotoFieldsFragmentDoc}`;
export const VesselDocumentsDocument = gql`
    query VesselDocuments($vesselId: ID!) {
  vesselDocuments(vesselId: $vesselId) {
    id
    vesselId
    docType
    title
    url
    r2Key
    issuedAt
    expiresAt
    notes
    createdAt
    updatedAt
  }
}
    `;
export const VesselMaintenanceLogsDocument = gql`
    query VesselMaintenanceLogs($vesselId: ID!) {
  vesselMaintenanceLogs(vesselId: $vesselId) {
    id
    vesselId
    performedAt
    engineHoursAtService
    workPerformed
    partsReplaced
    performedBy
    nextServiceDue
    nextServiceEngineHours
    notes
    createdAt
    updatedAt
  }
}
    `;
export const GenerateVesselDocumentUploadUrlDocument = gql`
    mutation GenerateVesselDocumentUploadUrl($vesselId: ID!, $filename: String!, $contentType: String!) {
  generateVesselDocumentUploadUrl(
    vesselId: $vesselId
    filename: $filename
    contentType: $contentType
  ) {
    uploadUrl
    key
  }
}
    `;
export const CreateVesselDocumentDocument = gql`
    mutation CreateVesselDocument($vesselId: ID!, $input: CreateVesselDocumentInput!) {
  createVesselDocument(vesselId: $vesselId, input: $input) {
    id
    vesselId
    docType
    title
    url
    r2Key
    issuedAt
    expiresAt
    notes
    createdAt
  }
}
    `;
export const DeleteVesselDocumentDocument = gql`
    mutation DeleteVesselDocument($id: ID!) {
  deleteVesselDocument(id: $id)
}
    `;
export const CreateVesselMaintenanceLogDocument = gql`
    mutation CreateVesselMaintenanceLog($vesselId: ID!, $input: CreateVesselMaintenanceLogInput!) {
  createVesselMaintenanceLog(vesselId: $vesselId, input: $input) {
    id
    vesselId
    performedAt
    engineHoursAtService
    workPerformed
    partsReplaced
    performedBy
    nextServiceDue
    nextServiceEngineHours
    notes
    createdAt
  }
}
    `;
export const CreateVesselDocument = gql`
    mutation CreateVessel($orgId: ID!, $input: CreateVesselInput!) {
  createVessel(orgId: $orgId, input: $input) {
    ...VesselFields
  }
}
    ${VesselFieldsFragmentDoc}`;
export const UpdateVesselDocument = gql`
    mutation UpdateVessel($id: ID!, $input: UpdateVesselInput!) {
  updateVessel(id: $id, input: $input) {
    ...VesselFields
  }
}
    ${VesselFieldsFragmentDoc}`;
export const UpdateVesselStatusDocument = gql`
    mutation UpdateVesselStatus($id: ID!, $status: VesselStatus!) {
  updateVesselStatus(id: $id, status: $status) {
    id
    status
  }
}
    `;
export const DeleteVesselDocument = gql`
    mutation DeleteVessel($id: ID!) {
  deleteVessel(id: $id)
}
    `;
export const GenerateVesselUploadUrlDocument = gql`
    mutation GenerateVesselUploadUrl($vesselId: ID!, $filename: String!, $contentType: String!) {
  generateVesselUploadUrl(
    vesselId: $vesselId
    filename: $filename
    contentType: $contentType
  ) {
    uploadUrl
    key
  }
}
    `;
export const AddVesselPhotoDocument = gql`
    mutation AddVesselPhoto($vesselId: ID!, $key: String!, $caption: String, $sizeBytes: Int) {
  addVesselPhoto(
    vesselId: $vesselId
    key: $key
    caption: $caption
    sizeBytes: $sizeBytes
  ) {
    ...VesselPhotoFields
  }
}
    ${VesselPhotoFieldsFragmentDoc}`;
export const SetVesselCoverPhotoDocument = gql`
    mutation SetVesselCoverPhoto($photoId: ID!) {
  setVesselCoverPhoto(photoId: $photoId) {
    id
    coverPhotoUrl
    photos {
      ...VesselPhotoFields
    }
  }
}
    ${VesselPhotoFieldsFragmentDoc}`;
export const DeleteVesselPhotoDocument = gql`
    mutation DeleteVesselPhoto($photoId: ID!) {
  deleteVesselPhoto(photoId: $photoId)
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    CertificatesList(variables: CertificatesListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CertificatesListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CertificatesListQuery>({ document: CertificatesListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CertificatesList', 'query', variables);
    },
    MyCertificates(variables?: MyCertificatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyCertificatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyCertificatesQuery>({ document: MyCertificatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MyCertificates', 'query', variables);
    },
    CertificateByCode(variables: CertificateByCodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CertificateByCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CertificateByCodeQuery>({ document: CertificateByCodeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CertificateByCode', 'query', variables);
    },
    IssueCertificate(variables: IssueCertificateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<IssueCertificateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IssueCertificateMutation>({ document: IssueCertificateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'IssueCertificate', 'mutation', variables);
    },
    RevokeCertificate(variables: RevokeCertificateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RevokeCertificateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RevokeCertificateMutation>({ document: RevokeCertificateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RevokeCertificate', 'mutation', variables);
    },
    RegenerateCertificatePdf(variables: RegenerateCertificatePdfMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RegenerateCertificatePdfMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegenerateCertificatePdfMutation>({ document: RegenerateCertificatePdfDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RegenerateCertificatePdf', 'mutation', variables);
    },
    CertPdfReady(variables: CertPdfReadySubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CertPdfReadySubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<CertPdfReadySubscription>({ document: CertPdfReadyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CertPdfReady', 'subscription', variables);
    },
    CharterListingsList(variables: CharterListingsListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CharterListingsListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CharterListingsListQuery>({ document: CharterListingsListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CharterListingsList', 'query', variables);
    },
    CharterBookingsList(variables: CharterBookingsListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CharterBookingsListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CharterBookingsListQuery>({ document: CharterBookingsListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CharterBookingsList', 'query', variables);
    },
    CreateCharterListing(variables: CreateCharterListingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateCharterListingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCharterListingMutation>({ document: CreateCharterListingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateCharterListing', 'mutation', variables);
    },
    UpdateCharterListing(variables: UpdateCharterListingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateCharterListingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCharterListingMutation>({ document: UpdateCharterListingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateCharterListing', 'mutation', variables);
    },
    DeleteCharterListing(variables: DeleteCharterListingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteCharterListingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCharterListingMutation>({ document: DeleteCharterListingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteCharterListing', 'mutation', variables);
    },
    ConfirmBooking(variables: ConfirmBookingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConfirmBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmBookingMutation>({ document: ConfirmBookingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ConfirmBooking', 'mutation', variables);
    },
    CancelBooking(variables: CancelBookingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CancelBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelBookingMutation>({ document: CancelBookingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CancelBooking', 'mutation', variables);
    },
    CrewProfile(variables: CrewProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrewProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrewProfileQuery>({ document: CrewProfileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrewProfile', 'query', variables);
    },
    CrewProfileDocuments(variables: CrewProfileDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrewProfileDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrewProfileDocumentsQuery>({ document: CrewProfileDocumentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrewProfileDocuments', 'query', variables);
    },
    CrewProfileCertificates(variables: CrewProfileCertificatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrewProfileCertificatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrewProfileCertificatesQuery>({ document: CrewProfileCertificatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrewProfileCertificates', 'query', variables);
    },
    CrewProfileMilesAwards(variables: CrewProfileMilesAwardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrewProfileMilesAwardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrewProfileMilesAwardsQuery>({ document: CrewProfileMilesAwardsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrewProfileMilesAwards', 'query', variables);
    },
    OrgCrewList(variables: OrgCrewListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<OrgCrewListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrgCrewListQuery>({ document: OrgCrewListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'OrgCrewList', 'query', variables);
    },
    OrgMembers(variables: OrgMembersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<OrgMembersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrgMembersQuery>({ document: OrgMembersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'OrgMembers', 'query', variables);
    },
    InviteMember(variables: InviteMemberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InviteMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InviteMemberMutation>({ document: InviteMemberDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'InviteMember', 'mutation', variables);
    },
    UpdateMemberRoles(variables: UpdateMemberRolesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateMemberRolesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMemberRolesMutation>({ document: UpdateMemberRolesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateMemberRoles', 'mutation', variables);
    },
    RemoveMember(variables: RemoveMemberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RemoveMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveMemberMutation>({ document: RemoveMemberDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveMember', 'mutation', variables);
    },
    DashboardExpeditions(variables: DashboardExpeditionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardExpeditionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardExpeditionsQuery>({ document: DashboardExpeditionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DashboardExpeditions', 'query', variables);
    },
    DashboardOrg(variables: DashboardOrgQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardOrgQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardOrgQuery>({ document: DashboardOrgDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DashboardOrg', 'query', variables);
    },
    DashboardMe(variables?: DashboardMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardMeQuery>({ document: DashboardMeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DashboardMe', 'query', variables);
    },
    MyDocuments(variables?: MyDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyDocumentsQuery>({ document: MyDocumentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MyDocuments', 'query', variables);
    },
    UserDocuments(variables: UserDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserDocumentsQuery>({ document: UserDocumentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UserDocuments', 'query', variables);
    },
    AddUserDocument(variables: AddUserDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddUserDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserDocumentMutation>({ document: AddUserDocumentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddUserDocument', 'mutation', variables);
    },
    PresignUserDocumentUpload(variables: PresignUserDocumentUploadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PresignUserDocumentUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PresignUserDocumentUploadMutation>({ document: PresignUserDocumentUploadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PresignUserDocumentUpload', 'mutation', variables);
    },
    ConfirmUserDocumentUpload(variables: ConfirmUserDocumentUploadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConfirmUserDocumentUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmUserDocumentUploadMutation>({ document: ConfirmUserDocumentUploadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ConfirmUserDocumentUpload', 'mutation', variables);
    },
    DeleteUserDocument(variables: DeleteUserDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteUserDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUserDocumentMutation>({ document: DeleteUserDocumentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteUserDocument', 'mutation', variables);
    },
    RoutesList(variables: RoutesListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RoutesListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutesListQuery>({ document: RoutesListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RoutesList', 'query', variables);
    },
    RouteDetail(variables: RouteDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RouteDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RouteDetailQuery>({ document: RouteDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RouteDetail', 'query', variables);
    },
    CreateRoute(variables: CreateRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRouteMutation>({ document: CreateRouteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateRoute', 'mutation', variables);
    },
    UpdateRoute(variables: UpdateRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRouteMutation>({ document: UpdateRouteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateRoute', 'mutation', variables);
    },
    DeleteRoute(variables: DeleteRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteRouteMutation>({ document: DeleteRouteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteRoute', 'mutation', variables);
    },
    AddWaypoint(variables: AddWaypointMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddWaypointMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddWaypointMutation>({ document: AddWaypointDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddWaypoint', 'mutation', variables);
    },
    ReorderWaypoints(variables: ReorderWaypointsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReorderWaypointsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReorderWaypointsMutation>({ document: ReorderWaypointsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ReorderWaypoints', 'mutation', variables);
    },
    AssignVessel(variables: AssignVesselMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AssignVesselMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignVesselMutation>({ document: AssignVesselDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AssignVessel', 'mutation', variables);
    },
    RemoveVessel(variables: RemoveVesselMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RemoveVesselMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveVesselMutation>({ document: RemoveVesselDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveVessel', 'mutation', variables);
    },
    SetCrewVessel(variables: SetCrewVesselMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetCrewVesselMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetCrewVesselMutation>({ document: SetCrewVesselDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetCrewVessel', 'mutation', variables);
    },
    ExpeditionsList(variables: ExpeditionsListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ExpeditionsListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExpeditionsListQuery>({ document: ExpeditionsListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ExpeditionsList', 'query', variables);
    },
    ExpeditionDetail(variables: ExpeditionDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ExpeditionDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExpeditionDetailQuery>({ document: ExpeditionDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ExpeditionDetail', 'query', variables);
    },
    CreateExpedition(variables: CreateExpeditionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateExpeditionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateExpeditionMutation>({ document: CreateExpeditionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateExpedition', 'mutation', variables);
    },
    UpdateExpeditionStatus(variables: UpdateExpeditionStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateExpeditionStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateExpeditionStatusMutation>({ document: UpdateExpeditionStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateExpeditionStatus', 'mutation', variables);
    },
    ExpeditionBySlug(variables: ExpeditionBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ExpeditionBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExpeditionBySlugQuery>({ document: ExpeditionBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ExpeditionBySlug', 'query', variables);
    },
    ExpeditionExpenses(variables: ExpeditionExpensesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ExpeditionExpensesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExpeditionExpensesQuery>({ document: ExpeditionExpensesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ExpeditionExpenses', 'query', variables);
    },
    ExpeditionExpensesList(variables: ExpeditionExpensesListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ExpeditionExpensesListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExpeditionExpensesListQuery>({ document: ExpeditionExpensesListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ExpeditionExpensesList', 'query', variables);
    },
    RecordExpense(variables: RecordExpenseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RecordExpenseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecordExpenseMutation>({ document: RecordExpenseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RecordExpense', 'mutation', variables);
    },
    DeleteExpense(variables: DeleteExpenseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteExpenseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteExpenseMutation>({ document: DeleteExpenseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteExpense', 'mutation', variables);
    },
    ApproveCrewMember(variables: ApproveCrewMemberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ApproveCrewMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApproveCrewMemberMutation>({ document: ApproveCrewMemberDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ApproveCrewMember', 'mutation', variables);
    },
    DeclineCrewMember(variables: DeclineCrewMemberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeclineCrewMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeclineCrewMemberMutation>({ document: DeclineCrewMemberDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeclineCrewMember', 'mutation', variables);
    },
    MarkNoShow(variables: MarkNoShowMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MarkNoShowMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkNoShowMutation>({ document: MarkNoShowDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MarkNoShow', 'mutation', variables);
    },
    MarkDisembarkedEarly(variables: MarkDisembarkedEarlyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MarkDisembarkedEarlyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkDisembarkedEarlyMutation>({ document: MarkDisembarkedEarlyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MarkDisembarkedEarly', 'mutation', variables);
    },
    ReinstateCrewMember(variables: ReinstateCrewMemberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReinstateCrewMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReinstateCrewMemberMutation>({ document: ReinstateCrewMemberDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ReinstateCrewMember', 'mutation', variables);
    },
    RemoveCrewMember(variables: RemoveCrewMemberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RemoveCrewMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCrewMemberMutation>({ document: RemoveCrewMemberDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveCrewMember', 'mutation', variables);
    },
    UpdateCrewMembershipRole(variables: UpdateCrewMembershipRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateCrewMembershipRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCrewMembershipRoleMutation>({ document: UpdateCrewMembershipRoleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateCrewMembershipRole', 'mutation', variables);
    },
    LogbookEntries(variables: LogbookEntriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LogbookEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogbookEntriesQuery>({ document: LogbookEntriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LogbookEntries', 'query', variables);
    },
    AddLogbookEntry(variables: AddLogbookEntryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddLogbookEntryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddLogbookEntryMutation>({ document: AddLogbookEntryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddLogbookEntry', 'mutation', variables);
    },
    DeleteLogbookEntry(variables: DeleteLogbookEntryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteLogbookEntryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteLogbookEntryMutation>({ document: DeleteLogbookEntryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteLogbookEntry', 'mutation', variables);
    },
    JoinExpedition(variables: JoinExpeditionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<JoinExpeditionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<JoinExpeditionMutation>({ document: JoinExpeditionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'JoinExpedition', 'mutation', variables);
    },
    LeaveExpedition(variables: LeaveExpeditionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LeaveExpeditionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LeaveExpeditionMutation>({ document: LeaveExpeditionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LeaveExpedition', 'mutation', variables);
    },
    InviteCrew(variables: InviteCrewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InviteCrewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InviteCrewMutation>({ document: InviteCrewDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'InviteCrew', 'mutation', variables);
    },
    SettleExpense(variables: SettleExpenseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SettleExpenseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SettleExpenseMutation>({ document: SettleExpenseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SettleExpense', 'mutation', variables);
    },
    RecordSettlement(variables: RecordSettlementMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RecordSettlementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecordSettlementMutation>({ document: RecordSettlementDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RecordSettlement', 'mutation', variables);
    },
    Me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>({ document: MeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Me', 'query', variables);
    },
    MyNotifications(variables?: MyNotificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyNotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyNotificationsQuery>({ document: MyNotificationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MyNotifications', 'query', variables);
    },
    UnreadCount(variables?: UnreadCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UnreadCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnreadCountQuery>({ document: UnreadCountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UnreadCount', 'query', variables);
    },
    MarkNotificationRead(variables: MarkNotificationReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MarkNotificationReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkNotificationReadMutation>({ document: MarkNotificationReadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MarkNotificationRead', 'mutation', variables);
    },
    MarkAllRead(variables?: MarkAllReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MarkAllReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkAllReadMutation>({ document: MarkAllReadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MarkAllRead', 'mutation', variables);
    },
    SendTestNotification(variables?: SendTestNotificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SendTestNotificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendTestNotificationMutation>({ document: SendTestNotificationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SendTestNotification', 'mutation', variables);
    },
    NotificationReceived(variables?: NotificationReceivedSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<NotificationReceivedSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotificationReceivedSubscription>({ document: NotificationReceivedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'NotificationReceived', 'subscription', variables);
    },
    CoursesList(variables: CoursesListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CoursesListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CoursesListQuery>({ document: CoursesListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CoursesList', 'query', variables);
    },
    CreateCourse(variables: CreateCourseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCourseMutation>({ document: CreateCourseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateCourse', 'mutation', variables);
    },
    UpdateCourse(variables: UpdateCourseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCourseMutation>({ document: UpdateCourseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateCourse', 'mutation', variables);
    },
    DeleteCourse(variables: DeleteCourseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteCourseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCourseMutation>({ document: DeleteCourseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteCourse', 'mutation', variables);
    },
    EnrolUser(variables: EnrolUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EnrolUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EnrolUserMutation>({ document: EnrolUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EnrolUser', 'mutation', variables);
    },
    OrgSettings(variables: OrgSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<OrgSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrgSettingsQuery>({ document: OrgSettingsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'OrgSettings', 'query', variables);
    },
    UpdateOrganisation(variables: UpdateOrganisationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateOrganisationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrganisationMutation>({ document: UpdateOrganisationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateOrganisation', 'mutation', variables);
    },
    GenerateOrgLogoUploadUrl(variables: GenerateOrgLogoUploadUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GenerateOrgLogoUploadUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateOrgLogoUploadUrlMutation>({ document: GenerateOrgLogoUploadUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GenerateOrgLogoUploadUrl', 'mutation', variables);
    },
    UpdateOrgPreferences(variables: UpdateOrgPreferencesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateOrgPreferencesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrgPreferencesMutation>({ document: UpdateOrgPreferencesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateOrgPreferences', 'mutation', variables);
    },
    SkillCategoriesList(variables: SkillCategoriesListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SkillCategoriesListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SkillCategoriesListQuery>({ document: SkillCategoriesListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SkillCategoriesList', 'query', variables);
    },
    CreateSkillCategory(variables: CreateSkillCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateSkillCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSkillCategoryMutation>({ document: CreateSkillCategoryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateSkillCategory', 'mutation', variables);
    },
    UpdateSkillCategory(variables: UpdateSkillCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateSkillCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSkillCategoryMutation>({ document: UpdateSkillCategoryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateSkillCategory', 'mutation', variables);
    },
    DeleteSkillCategory(variables: DeleteSkillCategoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteSkillCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSkillCategoryMutation>({ document: DeleteSkillCategoryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteSkillCategory', 'mutation', variables);
    },
    CreateSkill(variables: CreateSkillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateSkillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSkillMutation>({ document: CreateSkillDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateSkill', 'mutation', variables);
    },
    UpdateSkill(variables: UpdateSkillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateSkillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSkillMutation>({ document: UpdateSkillDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateSkill', 'mutation', variables);
    },
    DeleteSkill(variables: DeleteSkillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteSkillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSkillMutation>({ document: DeleteSkillDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteSkill', 'mutation', variables);
    },
    AddSkillLevel(variables: AddSkillLevelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddSkillLevelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddSkillLevelMutation>({ document: AddSkillLevelDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddSkillLevel', 'mutation', variables);
    },
    RemoveSkillLevel(variables: RemoveSkillLevelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RemoveSkillLevelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSkillLevelMutation>({ document: RemoveSkillLevelDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveSkillLevel', 'mutation', variables);
    },
    SkillAssessmentsForUser(variables: SkillAssessmentsForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SkillAssessmentsForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SkillAssessmentsForUserQuery>({ document: SkillAssessmentsForUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SkillAssessmentsForUser', 'query', variables);
    },
    RecordSkillAssessment(variables: RecordSkillAssessmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RecordSkillAssessmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecordSkillAssessmentMutation>({ document: RecordSkillAssessmentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RecordSkillAssessment', 'mutation', variables);
    },
    SkillTemplatesList(variables?: SkillTemplatesListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SkillTemplatesListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SkillTemplatesListQuery>({ document: SkillTemplatesListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SkillTemplatesList', 'query', variables);
    },
    ImportSkillTemplate(variables: ImportSkillTemplateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ImportSkillTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportSkillTemplateMutation>({ document: ImportSkillTemplateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ImportSkillTemplate', 'mutation', variables);
    },
    VesselPings(variables: VesselPingsSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VesselPingsSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<VesselPingsSubscription>({ document: VesselPingsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VesselPings', 'subscription', variables);
    },
    RecordVesselPing(variables: RecordVesselPingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RecordVesselPingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecordVesselPingMutation>({ document: RecordVesselPingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RecordVesselPing', 'mutation', variables);
    },
    VesselsList(variables: VesselsListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VesselsListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VesselsListQuery>({ document: VesselsListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VesselsList', 'query', variables);
    },
    VesselBySlug(variables: VesselBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VesselBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VesselBySlugQuery>({ document: VesselBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VesselBySlug', 'query', variables);
    },
    VesselDocuments(variables: VesselDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VesselDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VesselDocumentsQuery>({ document: VesselDocumentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VesselDocuments', 'query', variables);
    },
    VesselMaintenanceLogs(variables: VesselMaintenanceLogsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VesselMaintenanceLogsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VesselMaintenanceLogsQuery>({ document: VesselMaintenanceLogsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VesselMaintenanceLogs', 'query', variables);
    },
    GenerateVesselDocumentUploadUrl(variables: GenerateVesselDocumentUploadUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GenerateVesselDocumentUploadUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateVesselDocumentUploadUrlMutation>({ document: GenerateVesselDocumentUploadUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GenerateVesselDocumentUploadUrl', 'mutation', variables);
    },
    CreateVesselDocument(variables: CreateVesselDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateVesselDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVesselDocumentMutation>({ document: CreateVesselDocumentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateVesselDocument', 'mutation', variables);
    },
    DeleteVesselDocument(variables: DeleteVesselDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteVesselDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVesselDocumentMutation>({ document: DeleteVesselDocumentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteVesselDocument', 'mutation', variables);
    },
    CreateVesselMaintenanceLog(variables: CreateVesselMaintenanceLogMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateVesselMaintenanceLogMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVesselMaintenanceLogMutation>({ document: CreateVesselMaintenanceLogDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateVesselMaintenanceLog', 'mutation', variables);
    },
    CreateVessel(variables: CreateVesselMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateVesselMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVesselMutation>({ document: CreateVesselDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateVessel', 'mutation', variables);
    },
    UpdateVessel(variables: UpdateVesselMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateVesselMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVesselMutation>({ document: UpdateVesselDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateVessel', 'mutation', variables);
    },
    UpdateVesselStatus(variables: UpdateVesselStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateVesselStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVesselStatusMutation>({ document: UpdateVesselStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateVesselStatus', 'mutation', variables);
    },
    DeleteVessel(variables: DeleteVesselMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteVesselMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVesselMutation>({ document: DeleteVesselDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteVessel', 'mutation', variables);
    },
    GenerateVesselUploadUrl(variables: GenerateVesselUploadUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GenerateVesselUploadUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateVesselUploadUrlMutation>({ document: GenerateVesselUploadUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GenerateVesselUploadUrl', 'mutation', variables);
    },
    AddVesselPhoto(variables: AddVesselPhotoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddVesselPhotoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddVesselPhotoMutation>({ document: AddVesselPhotoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddVesselPhoto', 'mutation', variables);
    },
    SetVesselCoverPhoto(variables: SetVesselCoverPhotoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetVesselCoverPhotoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetVesselCoverPhotoMutation>({ document: SetVesselCoverPhotoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetVesselCoverPhoto', 'mutation', variables);
    },
    DeleteVesselPhoto(variables: DeleteVesselPhotoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteVesselPhotoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVesselPhotoMutation>({ document: DeleteVesselPhotoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteVesselPhoto', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;